/* eslint-disable  */
import { ArrowDropDown, CheckBox, Close } from '@mui/icons-material';
import {
	Button,
	Checkbox,
	IconButton,
	MenuItem,
	Select,
	Tooltip,
} from '@mui/material';
import { useReducer, useMemo, useEffect, useState, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import RangeSlider from 'rsuite/RangeSlider';
import {
	useLocation,
	useHistory,
} from 'react-router-dom/cjs/react-router-dom.min';
import SelectPicker from 'rsuite/SelectPicker';
import Slider from 'rsuite/Slider';
import {
	formActions,
	analyticsAction,
	brandActions,
	navigationActions,
	modalActions,
} from '../../Actions';
import {
	classes,
	inputHelper,
	mealTypeList,
	skuTypesListWithId,
	useQuery,
} from '../../Helpers';
import { UYDateRange } from '../Forms/Payment Settlements/Calender/UYDateRange';
import config from './config';
import styles from './ImagesFinder.module.scss';
import processFlowServices from '../../Services/Analytics Services/process-flow.services';
import inventoryAnalyticsServices from '../../Services/Analytics Services/inventory-analytics.services';
import DatePickerCustom from '../DatePickerCustom/DatePickerCustom';
import { urls } from '@/Constants';
import BaseDrawer from '../Drawers/BaseDrawer/BaseDrawer';
import drawerActions from '@/Actions/drawer.actions';
import { Accordion, CheckPicker, CheckTreePicker, Stack } from 'rsuite';
import {
	Ban,
	Calendar,
	ChevronDown,
	Cuboid,
	LoaderCircle,
	Settings,
	Store,
	Upload,
} from 'lucide-react';
import moment from 'moment';
import productionPlanServices from '@/Services/Analytics Services/production-plan.services';
import { notificationServices } from '@/Services';

const Header = (props) => {
	const { icon, title, subtitle, ...rest } = props;
	return (
		<Stack {...rest} spacing={10} alignItems='center' direction='row'>
			<div
				style={{
					width: 16,
					height: 16,
					display: 'flex',
					alignItems: 'center',
				}}
			>
				{icon}
			</div>
			<Stack spacing={2} direction='column' alignItems='flex-start'>
				<div style={{ fontSize: 12 }}>{title}</div>
				{subtitle && (
					<div
						style={{
							color: 'var(--rs-text-secondary)',
							fontSize: 12,
						}}
					>
						{subtitle}
					</div>
				)}
			</Stack>
		</Stack>
	);
};

const identificationTypes = [
	{
		id: 1,
		type: 'AI',
	},
	{
		id: 2,
		type: 'Manual',
	},
	{
		id: 3,
		type: 'Both',
	},
];

const POSSIBLE_IMAGE_TYPES = [
	{
		id: 1,
		label: 'ASSET',
		returnValue: 'ASSET',
	},
	{
		id: 2,
		label: 'TRANSIT',
		returnValue: 'TRANSIT',
	},
	{
		id: 3,
		label: 'BOTH',
		returnValue: 'BOTH',
	},
];

const EMPTYVALUE = -999;

const defaultTimeTypeArr = [
	{
		label: 'Annotation Time',
		value: 'annotation',
	},
	{
		label: 'QC Time',
		value: 'qc',
	},
];

const typesList = [
	{
		name: 'QUALITY',
		value: 'QUALITY',
	},
	{
		name: 'IDENTITY',
		value: 'IDENTITY',
	},
];

const CONFIDENCE_LIST = [
	{
		label: 'Less than',
		value: 'Lessthan',
	},
	{
		label: 'Greater than',
		value: 'Greaterthan',
	},
	{
		label: 'with Range',
		value: 'withRange',
	},
];

function calculateDate(duration) {
	const currentDate = new Date();

	if (duration === 'Week') {
		// Subtract 7 days from the current date
		currentDate.setDate(currentDate.getDate() - 7);
	} else if (duration === 'Month') {
		// Subtract 1 month from the current date
		currentDate.setMonth(currentDate.getMonth() - 1);
	}

	return currentDate;
}

const reducer = (state, action) => {
	switch (action.type) {
		case 'SET_PRODUCTION_PLAN':
			return {
				...state,
				productionPlan: action.payload,
			};
		case 'SET_TYPE':
			return {
				...state,
				type: action.payload,
			};
		case 'SET_DELIVER_FROM':
			return {
				...state,
				deliverFrom: action.payload,
			};
		case 'SET_BRAND':
			return {
				...state,
				brand: action.payload,
			};
		case 'SET_STORE':
			return {
				...state,
				store: action.payload,
			};
		case 'SET_FROM_POD':
			return {
				...state,
				fromPod: action.payload,
			};
		case 'SET_TO_POD':
			return {
				...state,
				toPod: action.payload,
			};
		case 'SET_RAISED_BY_STORE':
			return {
				...state,
				raisedBy: action.payload,
			};
		case 'SET_PROCESS_TYPE':
			return {
				...state,
				processType: action.payload,
			};
		case 'SET_FROM_PROCESS':
			return {
				...state,
				fromProcess: action.payload,
			};
		case 'SET_TO_PROCESS':
			return {
				...state,
				toProcess: action.payload,
			};
		case 'SET_FEATURE_TYPE':
			return {
				...state,
				featureType: action.payload,
			};
		case 'SET_PAGE':
			return {
				...state,
				page: action.payload,
			};
		case 'SET_IMAGES_TYPE':
			return {
				...state,
				imagesType: action.payload,
			};
		case 'SET_DEFECTS':
			return {
				...state,
				defects: action.payload,
			};
		case 'SET_VENDORS':
			return {
				...state,
				vendors: action.payload,
			};
		case 'SET_VENDOR':
			return {
				...state,
				vendor: action.payload,
			};
		case 'SET_CONFIDENCE':
			return {
				...state,
				confidence: action.payload,
			};
		case 'SET_IDENTIFICATION_TYPE':
			return {
				...state,
				identificationType: action.payload,
			};
		case 'SET_PRODUCT_CATEGORY':
			return {
				...state,
				productCategories: action.payload,
			};
		case 'SET_PRODUCT_CATEGORY_SINGLE':
			return {
				...state,
				productCategory: action.payload,
			};
		case 'SET_PRODUCTS':
			return {
				...state,
				products: action.payload,
			};
		case 'SET_PRODUCT':
			return {
				...state,
				product: action.payload,
			};
		case 'SET_PRODUCT_WITH_VARIANTS':
			return {
				...state,
				productWithVariant: action.payload,
			};
		case 'SET_PRODUCT_EXCLUSIVE':
			return {
				...state,
				productExclusive: action.payload,
			};
		case 'SET_INGREDIENT':
			return {
				...state,
				ingredient: action.payload,
			};
		case 'SET_TIME_TYPE':
			return {
				...state,
				timeType: action.payload,
			};
		case 'SET_DATE_RANGE':
			return {
				...state,
				dateRange: action.payload,
			};
		case 'SET_STATUS':
			return {
				...state,
				status: action.payload,
			};
		case 'SET_GROUP':
			return {
				...state,
				group: action.payload,
			};
		case 'SET_REGION':
			return {
				...state,
				region: action.payload,
			};
		case 'SET_CUSTOM_EXCLUSIVE_FILTER':
			return {
				...state,
				customExclusiveFilters: {
					...action.payload,
				},
			};
		case 'SET_DATE_ONLY':
			return {
				...state,
				dateOnly: {
					...action.payload,
				},
			};
		case 'SET_STATE':
			return {
				...state,
				...action.payload,
			};
		case 'SET_PAYMENT_TYPE':
			return {
				...state,
				paymentType: action.payload,
			};
		case 'SET_PAYMENT_STATUS':
			return {
				...state,
				paymentStatus: action.payload,
			};
		case 'SET_BRAND':
			return {
				...state,
				brand: action.payload,
			};
		case 'SET_ORDER_TYPE':
			return {
				...state,
				orderType: action.payload,
			};
		case 'SET_EXPORT_TYPE':
			return {
				...state,
				exportType: action.payload,
			};
		case 'SET_SKU_TYPE':
			return {
				...state,
				skuType: action.payload,
			};
		case 'SET_SKU_TYPE_MULTI':
			return {
				...state,
				skuTypeMulti: action.payload,
			};
		case 'SET_ALL_PROCESS_TYPE':
			return {
				...state,
				allProcessType: action.payload,
			};
		case 'SET_ALL_PROCESS_TYPE_MULTI':
			return {
				...state,
				allProcessTypeMulti: action.payload,
			};
		case 'SET_MEAL_TYPE':
			return {
				...state,
				mealType: action.payload,
			};
		case 'SET_MEAL_TYPE_MULTI':
			return {
				...state,
				mealTypeMulti: action.payload,
			};
		case 'SET_MULTI_STORE':
			return {
				...state,
				multiStore: action.payload,
			};
		case 'SET_FILTER_MULTI_STORE':
			return {
				...state,
				filterMultiStore: action.payload,
			};
		case 'SET_DUPLICATE':
			return {
				...state,
				duplicate: action.payload,
			};
		case 'SET_VALIDATION':
			return {
				...state,
				validation: action.payload,
			};
		case 'SET_IDENTIFIED':
			return {
				...state,
				identified: action.payload,
			};
		case 'SET_FEATURE':
			return {
				...state,
				feature: action.payload,
			};
		case 'SET_TAB':
			return {
				...state,
				tab: action.payload,
			};
		case 'SET_LONG_TERM_PLAN_MULTI':
			return {
				...state,
				longtermMultiSelect: action.payload,
			};
		case 'SET_LONG_TERM_PLAN':
			return {
				...state,
				longtermSingleSelect: action.payload,
			};
		case 'SET_PRODUCTION_PLAN_GENERATED':
			return {
				...state,
				productionPlanStatus: action.payload,
			};
		case 'SET_SHIFT':
			return {
				...state,
				shift: action.payload,
			};
		default:
			return state;
	}
};

const defaultStatusList = [
	{
		id: 'ALL',
		title: 'ALL',
	},
	{
		id: 'CANCELLED',
		title: 'CANCELLED',
	},
	{
		id: 'PENDING',
		title: 'PENDING',
	},
	{
		id: 'FULFILLED',
		title: 'CLOSED',
	},
	{
		id: 'ABANDONED',
		title: 'ABANDONED',
	},
];
function alterInitialState(changeObj = null) {
	const initialState = { ...config?.initialState };
	if (!changeObj) {
		return initialState;
	}
	Object.keys(changeObj).forEach((key) => {
		if (
			initialState[key] &&
			typeof initialState[key] === 'object' &&
			!Array.isArray(initialState[key]) &&
			changeObj[key] &&
			typeof changeObj[key] === 'object' &&
			!Array.isArray(changeObj[key]) &&
			changeObj[key] !== null &&
			!(changeObj[key] instanceof Date) &&
			!(initialState[key] instanceof Date)
		) {
			initialState[key] = { ...initialState[key], ...changeObj[key] };
		} else {
			initialState[key] = changeObj[key];
		}
	});
	return initialState;
}

const ImagesFinder = (props) => {
	const [state, dispatch] = useReducer(
		reducer,
		props?.initialState,
		(initialArg) => alterInitialState(initialArg)
	);
	const [shouldAnimate, setShouldAnimate] = useState(true);
	const query = useQuery();
	const history = useHistory();
	const paramNavSelected = query.get('paramNavSelected');

	const {
		deliverFrom,
		store,
		fromPod,
		toPod,
		vendors,
		vendor,
		processType,
		raisedBy,
		products,
		product,
		productExclusive,
		ingredient,
		featureType,
		defects,
		toProcess,
		fromProcess,
		identificationType,
		imagesType,
		timeType,
		page: pageLimit,
		dateRange,
		dateOnly,
		productCategories,
		productCategory,
		status,
		group,
		region,
		type,
		productionPlanDuration,
		productionPlan,
		confidence,
		paymentType,
		paymentStatus,
		brand,
		customExclusiveFilters,
		orderType,
		exportType,
		skuType,
		productWithVariant,
		skuTypeMulti,
		allProcessType,
		allProcessTypeMulti,
		mealType,
		mealTypeMulti,
		multiStore,
		filterMultiStore,
		duplicate,
		validation,
		identified,
		feature,
		tab,
		longtermMultiSelect,
		longtermSingleSelect,
		productionPlanStatus,
		shift,
	} = state;
	const {
		DEFAULT_FILTERS_VALUE = [],
		// hideProductSelection,
		toggleModal,
		productsList,
		fetchProducts,
		stores,
		permittedStores = [],
		groups,
		regions,
		setParentFilterState = () => { },
		onSubmit,
		fetchStoresList,
		brands,
		fetchBrands,
		isInternal = true,
		hideFinder = false,
		buyersList,
		productCategoriesList,
		fetchProductCategoriesList,
		vendorsList,
		avoidInitialCall = false,
		fetchAllVendors,
		fetchDefects,
		defectsList,
		blink,

		// fetchProcessTypesList,
		// processTypes,
		// searchHandler = {},
		update = null,
		allStoreOption = true,
		// allGroupOption = true,
		storeTypes = '',
		groupTypes = '',
		setAutoStore = true,
		// setAutoGroup = true,
		preventDateRangeCheckbox = false,
		// allowFutureDate = false,
		externalFilters = [],
		// eslint-disable-next-line no-unused-vars
		getParentRequisites,
		// eslint-disable-next-line no-unused-vars
		statusList = [],
		timeTypeArray,
		defaultState = {},
		conditionalFilters = [],
		filterLabels = {},
		footerComponent = null,
		headerComponent = () => { },
		onUpdate = () => { },
		maxConf = 1,
		minConf = 0.01,
		step = 0.01,
		disableFutureDate = false,
		orderText = false,
		toggleFiltersDrawer,
		show,
		data,
		hideDateRangeTimeType = false,
		filtersInfo = {},
		productionPlans,
		fetchProductionPlans,
		tabType = '',
		navState,
		exportInfo = {},
		cleanable = {},
	} = props;
	const {
		handleDataExport = () => { },
		exportFrontend = false,
		handleExportFrontend = () => { },
	} = data ?? {};

	const reduxDispatch = useDispatch();
	const location = useLocation();
	const [processTypes, setProcessTypes] = useState([]);
	// Shifts of the selected Deliver From store, fetched here rather than passed in so the
	// list always reflects the store currently picked in the drawer.
	const [shifts, setShifts] = useState([]);
	const [sliderValue, setSliderValue] = useState([minConf, maxConf]);
	const [egaPercentage, setEgaPercentage] = useState({
		value: 0.1,
		checked: false,
	});
	const [filteredState, setFilteredState] = useState({});
	const [productTreeSearch, setProductTreeSearch] = useState('');
	const [longTermPlans, setLongTermPlans] = useState([]);
	const currentPath = location?.pathname?.split(urls.EXTENSION);

	// Kitchen is a hard scope on some screens (every number is read per kitchen),
	// so those pages mark it mandatory: the drawer pre-picks the first kitchen and
	// refuses to apply without one.
	const isKitchenMandatory =
		(filtersInfo?.kitchenBaseStore?.show ?? false) &&
		(filtersInfo?.kitchenBaseStore?.mandatory ?? false);
	const defaultKitchenAppliedRef = useRef(false);

	// Same opt-in pattern as isKitchenMandatory, for the plain `store` and
	// `processType` filters (e.g. the Process Stock report, where a query
	// scoped to neither cannot be answered).
	const isStoreMandatory =
		(filtersInfo?.store?.show ?? false) &&
		(filtersInfo?.store?.mandatory ?? false);
	const isProcessTypeMandatory =
		(filtersInfo?.processType?.show ?? false) &&
		(filtersInfo?.processType?.mandatory ?? false);

	const pageUrls = [
		'/analytics/feature/images',
		'/analytics/temperature/digit/images',
		'/analytics/app/outwarding/images',
		'/analytics/ai/dispatch/images',
		'/analytics/wastage/images',
		'/analytics/production/images',
		'/analytics/cooking/images',
		'/analytics/temperature/images',
		'/analytics/ai/grn/images',
	];
	const containerRef = useRef(null);
	const navRequisites =
		reduxDispatch(
			navigationActions.getParentRequisites(currentPath?.[1])
		) ?? [];
	const navSelectedStore = navRequisites?.find((ele) => {
		return ele?.type === 'store';
	});
	const navStoreFilter = {
		id: navSelectedStore?.value?.id,
		type: 'billFrom',
		title: `By: ${navSelectedStore?.value?.name}`,
		removable: false,
	};

	async function fetchNodes() {
		try {
			const response = await processFlowServices?.fetchNodes({
				params: {
					...(filtersInfo['allProcessType']?.show
						? {}
						: {
							...(store?.id !== EMPTYVALUE && {
								storeId: store?.id,
							}),
						}),
				},
			});
			if (response?.statusCode === 200) {
				const { nodes } = response?.data ?? {};
				setProcessTypes(nodes);
			}
		} catch (error) {
			console.error('Error:', error);
		}
	}

	// Shifts are configured per store, so the list is the Deliver From store's shifts.
	// With no store picked (or the "all stores" sentinel) there is no shift set to offer,
	// so the dropdown falls back to just 'All'.
	async function fetchShifts() {
		try {
			if (!deliverFrom?.id || deliverFrom?.id === EMPTYVALUE) {
				setShifts([]);
				return;
			}
			// storeId is what scopes the list - the backend returns that store's shifts.
			// The shared analytics SHIFT_LIST in redux is fetched without it (every shift
			// of the customer) and is used by other screens, so it is not reused here.
			const response = await inventoryAnalyticsServices?.fetchShifts({
				params: {
					storeId: deliverFrom?.id,
				},
			});
			if (response?.statusCode === 200) {
				setShifts(response?.data ?? []);
			} else {
				setShifts([]);
			}
		} catch (error) {
			// A missing shift list must not block the drawer; 'All' is still offered,
			// which is the unfiltered behaviour anyway.
			console.error('Error:', error);
			setShifts([]);
		}
	}

	useEffect(() => {
		if (paramNavSelected) {
			const entry = Object.entries(navState)?.find(([_, value]) =>
				Object.keys(value?.submenu || {}).includes(currentPath[1])
			);
			const selectedNavRequisite = {
				id: -999,
				name: 'ALL',
			};
			const navKey = entry?.[0];
			const newRequisite = entry?.[1]?.requisites?.map((ele) => {
				if (ele?.type === 'store') {
					return {
						...ele,
						value: selectedNavRequisite,
					};
				}
				return ele;
			});
			reduxDispatch(
				navigationActions?.handleNavRequisite(
					navKey,
					newRequisite,
					null,
					location?.pathname
				)
			);
			reduxDispatch(modalActions.toggleNavItemRequisitesModal(false));
		}
	}, [paramNavSelected]);

	useEffect(() => {
		const date = calculateDate(productionPlanDuration);

		fetchProductionPlans({
			entity: 'PRODUCTION_PLANS',
			req: {
				data: {
					filters: {
						dateRangeFilter: {
							from: moment(date)?.format('YYYY-MM-DD'),
							to: moment(new Date())?.format('YYYY-MM-DD'),
						},
						recentOnly: true,
					},
				},
			},
			method: 'LIST',
		});
	}, [productionPlanDuration]);

	useEffect(() => {
		const searchParams = new URLSearchParams();
		const existingParams = new URLSearchParams(window.location.search);
		existingParams.forEach((value, key) => {
			searchParams.set(key, value);
		});
		Object.entries(state).forEach(([key, value]) => {
			if (value !== undefined && value !== null) {
				if (Array.isArray(value) && value.length > 0) {
					searchParams.set(key, JSON.stringify(value));
				} else if (
					typeof value === 'object' &&
					value.from &&
					value.to
				) {
					searchParams.set(key, JSON.stringify(value));
				} else if (typeof value === 'object') {
					searchParams.set(key, JSON.stringify(value));
				} else {
					searchParams.set(key, JSON.stringify(value));
				}
			} else {
				searchParams.delete(key);
			}
		});
		const prevPath = history?.location?.state?.prevPath;
		const prevSearch = history?.location?.state?.prevSearch;
		const search = searchParams.toString();
		history.replace(
			{ search: search ? `?${search}` : '' },
			{ prevPath: prevPath, prevSearch: prevSearch }
		);
	}, [state]);

	useEffect(() => {
		if (
			(history?.location?.pathname ===
				urls.EXTENSION + urls.BUYER_ORDER_LIST &&
				history?.location?.state?.prevPath ===
				urls.EXTENSION + urls.VENDOR_ORDER_LIST) ||
			(history?.location?.pathname ===
				urls.EXTENSION + urls.VENDOR_ORDER_LIST &&
				history?.location?.state?.prevPath ===
				urls.EXTENSION + urls.BUYER_ORDER_LIST) ||
			(history?.location?.pathname ===
				urls.EXTENSION + urls.INTERNAL_PURCHASE_ORDERS_LIST &&
				history?.location?.state?.prevPath ===
				urls.EXTENSION + urls.VENDOR_ORDER_LIST) ||
			(history?.location?.pathname ===
				urls.EXTENSION + urls.VENDOR_ORDER_LIST &&
				history?.location?.state?.prevPath ===
				urls.EXTENSION + urls.INTERNAL_PURCHASE_ORDERS_LIST) ||
			(history?.location?.pathname ===
				urls.EXTENSION + urls.INTERNAL_PURCHASE_ORDERS_LIST &&
				history?.location?.state?.prevPath ===
				urls.EXTENSION + urls.BUYER_ORDER_LIST) ||
			(history?.location?.pathname ===
				urls.EXTENSION + urls.BUYER_ORDER_LIST &&
				history?.location?.state?.prevPath ===
				urls.EXTENSION + urls.INTERNAL_PURCHASE_ORDERS_LIST) ||
			(history?.location?.pathname ===
				urls.EXTENSION + urls.VENDOR_CONTRACT &&
				history?.location?.state?.prevPath ===
				urls.EXTENSION + urls.BUYER_CONTRACT) ||
			(history?.location?.pathname ===
				urls.EXTENSION + urls.BUYER_CONTRACT &&
				history?.location?.state?.prevPath ===
				urls.EXTENSION + urls.VENDOR_CONTRACT)
		) {
			dispatch({ type: 'SET_STATE', payload: config?.initialState });
		} else if (query.size > 0) {
			const newState = {};
			query.forEach((value, key) => {
				try {
					const parsedValue = JSON.parse(value);
					if (Array.isArray(parsedValue)) {
						newState[key] = parsedValue;
					} else if (
						typeof parsedValue === 'object' &&
						parsedValue !== null
					) {
						if (key === 'dateRange' || key === 'dateOnly') {
							const processedValue = { ...parsedValue };
							Object.keys(processedValue).forEach((subKey) => {
								if (
									typeof processedValue[subKey] ===
									'string' &&
									!isNaN(Date.parse(processedValue[subKey]))
								) {
									processedValue[subKey] = new Date(
										processedValue[subKey]
									);
								}
							});
							newState[key] = processedValue;
						} else {
							newState[key] = parsedValue;
						}
					} else {
						newState[key] = parsedValue;
					}
				} catch (error) {
					if (!isNaN(Date.parse(value))) {
						newState[key] = new Date(value);
					} else {
						newState[key] = value;
					}
				}
			});
			if (!avoidInitialCall) {
				handleSubmitParams(newState);
			}
			setFilteredState(newState);
		} else if (
			query.size === 0 &&
			!pageUrls.includes(currentPath?.[1]) &&
			!avoidInitialCall
		) {
			handleSubmitParams({
				...state,
				deliverFrom: {
					id: navSelectedStore?.value?.id,
					name: navSelectedStore?.value?.name,
				},
				timeType: {
					value: timeTypeArray?.[0]?.value,
					label: timeTypeArray?.[0]?.label,
				},
			});
		}
	}, [history?.location?.pathname, history?.location?.state?.prevPath]);

	useEffect(() => {
		dispatch({ type: 'SET_STATE', payload: filteredState });
	}, [filteredState]);

	useEffect(() => {
		if (store?.id === EMPTYVALUE) {
			dispatch({
				type: 'SET_PROCESS_TYPE',
				payload: {
					id: null,
					name: '',
				},
			});
		}
	}, [store]);

	useEffect(async () => {
		if (filtersInfo?.['longTermPlan']?.show && state?.fromPod?.id) {
			try {
				const response =
					await productionPlanServices.listLongTermProductionPlan({
						data: {
							startDate: moment(state?.dateRange?.from).format(
								'YYYY-MM-DD'
							),
							endDate: moment(state?.dateRange?.to).format(
								'YYYY-MM-DD'
							),
							storeId:
								state?.fromPod?.id === -999
									? null
									: state?.fromPod?.id,
						},
					});
				if (response?.statusCode === 200) {
					setLongTermPlans(response?.data || []);
				}
			} catch (error) {
				console.log(error);
			}
		}
	}, [
		state?.fromPod?.id,
		state?.dateRange?.from,
		state?.dateRange?.to,
		filtersInfo?.['longTermPlan']?.show,
	]);

	useEffect(() => {
		if (filtersInfo['tab']?.show) {
			selectTabType(filtersInfo['tab']?.list?.[0]?.id);
		}
	}, []);

	useEffect(() => {
		const req = config?.deserializer(
			{
				store:
					store?.id === EMPTYVALUE ? { ...store, id: null } : store,
				multiStore,
				filterMultiStore,
				group:
					group?.id === EMPTYVALUE ? { ...group, id: null } : group,
				region:
					region?.id === EMPTYVALUE
						? { ...region, id: null }
						: region,
				productExclusive:
					productExclusive?.id === EMPTYVALUE
						? { ...productExclusive, id: null }
						: productExclusive,
				ingredient:
					ingredient?.id === EMPTYVALUE
						? { ...ingredient, id: null }
						: ingredient,
				processTypes:
					processType?.id === EMPTYVALUE
						? { ...processType, id: null }
						: processType,
				fromProcess,
				toProcess,
				vendors,
				vendor,
				products,
				product,
				brand,
				productWithVariant,
				imagesType: POSSIBLE_IMAGE_TYPES?.find((ele) => {
					return ele?.id === imagesType;
				})?.returnValue,
				productCategories,
				productCategory,
				identificationType,
				featureType,
				conf: {
					minConf: Math.min(sliderValue[0], sliderValue[1]),
					maxConf: Math.max(sliderValue[0], sliderValue[1]),
				},
				egaPercentage,
				timeType,
				pageLimit,
				dateRange,
				dateOnly,
				status,
				type: type === 'Select Type' ? null : type,
				deliverFrom:
					deliverFrom?.id === EMPTYVALUE
						? { ...deliverFrom, id: null }
						: deliverFrom,
				customExclusiveFilters: state?.customExclusiveFilters,
				paymentType,
				paymentStatus,
				productionPlan,
				orderType,
				skuType,
				skuTypeMulti,
				allProcessType,
				allProcessTypeMulti,
				duplicate,
				validation,
				identified,
				feature,
				tab,
				productionPlanStatus,
				shift,
			},
			isInternal,
			Array.isArray(DEFAULT_FILTERS_VALUE) ? DEFAULT_FILTERS_VALUE : [],
			filtersInfo
		);
		onUpdate(req);
	}, [state]);

	const handleSubmit = (e) => {
		if (e) {
			e.preventDefault();
		}

		// Screens that scope every metric to one kitchen opt in with `mandatory`;
		// applying without one would fire a query that cannot be answered, so the
		// drawer stays open and says what is missing.
		if (isKitchenMandatory && !fromPod?.id) {
			notificationServices?.generateNotification({
				type: 'error',
				message: `${filtersInfo?.kitchenBaseStore?.text?.trim() || 'Kitchen'} is mandatory`,
			});
			return;
		}
		if (isStoreMandatory && (!store?.id || store?.id === EMPTYVALUE)) {
			notificationServices?.generateNotification({
				type: 'error',
				message: `${filtersInfo?.store?.text?.replace('*', '').trim() || 'Store'} is mandatory`,
			});
			return;
		}
		if (isProcessTypeMandatory && (!processType?.id || processType?.id === EMPTYVALUE)) {
			notificationServices?.generateNotification({
				type: 'error',
				message: 'Process Type is mandatory',
			});
			return;
		}

		const req = config?.deserializer(
			{
				store:
					store?.id === EMPTYVALUE ? { ...store, id: null } : store,
				multiStore: multiStore,
				filterMultiStore: filterMultiStore,
				fromPod:
					fromPod?.id === EMPTYVALUE
						? { ...fromPod, id: null }
						: fromPod,
				toPod:
					toPod?.id === EMPTYVALUE ? { ...toPod, id: null } : toPod,
				group:
					group?.id === EMPTYVALUE ? { ...group, id: null } : group,
				region:
					region?.id === EMPTYVALUE
						? { ...region, id: null }
						: region,
				productExclusive:
					productExclusive?.id === EMPTYVALUE
						? { ...productExclusive, id: null }
						: productExclusive,
				ingredient:
					ingredient?.id === EMPTYVALUE
						? { ...ingredient, id: null }
						: ingredient,
				processTypes:
					processType?.id === EMPTYVALUE
						? { ...processType, id: null }
						: processType,
				fromProcess,
				toProcess,
				vendors,
				vendor,
				products,
				product,
				productWithVariant,
				brand,
				imagesType: POSSIBLE_IMAGE_TYPES?.find((ele) => {
					return ele?.id === imagesType;
				})?.returnValue,
				productCategories,
				productCategory,
				identificationType,
				featureType,
				conf: {
					minConf: Math.min(sliderValue[0], sliderValue[1]),
					maxConf: Math.max(sliderValue[0], sliderValue[1]),
				},
				egaPercentage,
				timeType,
				pageLimit,
				dateRange,
				dateOnly,
				status,
				type: type === 'Select Type' ? null : type,
				deliverFrom:
					deliverFrom?.id === EMPTYVALUE
						? { ...deliverFrom, id: null }
						: deliverFrom,
				customExclusiveFilters: state?.customExclusiveFilters,
				paymentType,
				paymentStatus,
				productionPlan,
				orderType,
				skuType,
				skuTypeMulti,
				allProcessType,
				allProcessTypeMulti,
				mealType,
				mealTypeMulti,
				duplicate,
				validation,
				identified,
				feature,
				tab,
				longtermMultiSelect,
				longtermSingleSelect,
				productionPlanStatus,
				shift,
			},
			isInternal,
			Array.isArray(DEFAULT_FILTERS_VALUE) ? DEFAULT_FILTERS_VALUE : [],
			filtersInfo
		);
		onSubmit(req);
		toggleFiltersDrawer(false);
	};

	const handleSubmitParams = (data) => {
		const req = config?.deserializer(
			{
				store:
					data?.store?.id === EMPTYVALUE
						? { ...data?.store, id: null }
						: data?.store ??
						(store?.id === EMPTYVALUE
							? { ...store, id: null }
							: store),
				fromPod:
					data?.fromPod?.id === EMPTYVALUE
						? { ...data?.fromPod, id: null }
						: data?.fromPod ??
						(fromPod?.id === EMPTYVALUE
							? { ...fromPod, id: null }
							: fromPod),
				toPod:
					data?.toPod?.id === EMPTYVALUE
						? { ...data?.toPod, id: null }
						: data?.toPod ??
						(toPod?.id === EMPTYVALUE
							? { ...toPod, id: null }
							: toPod),
				group:
					data?.group?.id === EMPTYVALUE
						? { ...data?.group, id: null }
						: data?.group ??
						(group?.id === EMPTYVALUE
							? { ...group, id: null }
							: group),
				region:
					data?.region?.id === EMPTYVALUE
						? { ...data?.region, id: null }
						: data?.region ??
						(region?.id === EMPTYVALUE
							? { ...region, id: null }
							: region),
				multiStore: data?.multiStore,
				filterMultiStore: data?.filterMultiStore,
				productExclusive:
					data?.productExclusive ??
					(Number(data?.productExclusive?.id) === EMPTYVALUE
						? { ...data?.productExclusive, id: null }
						: data?.productExclusive) ??
					(Number(productExclusive?.id) === EMPTYVALUE
						? { ...productExclusive, id: null }
						: productExclusive),
				ingredient:
					data?.ingredient ??
					(Number(ingredient?.id) === EMPTYVALUE
						? { ...ingredient, id: null }
						: ingredient),
				processTypes:
					data?.processType ??
					(processType === EMPTYVALUE
						? { ...processType, id: null }
						: processType),
				fromProcess: data?.fromProcess ?? fromProcess,
				toProcess: data?.toProcess ?? toProcess,
				vendors: data?.vendors?.id ? data?.vendors : vendors,
				vendor: data?.vendor?.id ? data?.vendor : vendor,
				products: data?.products?.id ? data?.products : products,
				product: data?.product?.id ? data?.product : product,
				productWithVariant:
					data?.productWithVariant ?? productWithVariant,
				productCategories: data?.productCategories?.id
					? data?.productCategories
					: productCategories,
				productCategory:
					data?.productCategory?.id ?? productCategory?.id,
				identificationType:
					data?.identificationType ?? identificationType,
				featureType: data?.featureType ?? featureType,
				conf: data?.conf ?? {
					minConf: Math.min(sliderValue[0], sliderValue[1]),
					maxConf: Math.max(sliderValue[0], sliderValue[1]),
				},
				timeType: data?.timeType ?? timeType,
				egaPercentage: data?.egaPercentage,
				pageLimit: data?.pageLimit ?? pageLimit,
				dateRange: data?.dateRange ?? dateRange,
				dateOnly: data?.dateOnly,
				status: data?.status,
				brand: data?.brand ?? brand,
				type: data?.type === 'Select Type' ? null : data?.type,
				deliverFrom:
					data?.deliverFrom ??
					(deliverFrom?.id === EMPTYVALUE ? null : deliverFrom),
				paymentType: data?.paymentType,
				paymentStatus: data?.paymentStatus,
				productionPlan: data?.productionPlan,
				orderType: data?.orderType ?? orderType,
				skuType: data?.skuType,
				skuTypeMulti: data?.skuTypeMulti,
				allProcessType: data?.allProcessType,
				allProcessTypeMulti: data?.allProcessTypeMulti,
				mealType: data?.mealType,
				mealTypeMulti: data?.mealTypeMulti,
				duplicate: data?.duplicate,
				validation: data?.validation,
				identified: data?.identified,
				feature: data?.feature,
				tab: data?.tab,
				longtermMultiSelect: data?.longtermMultiSelect,
				longtermSingleSelect: data?.longtermSingleSelect,
			},
			isInternal,
			Array.isArray(DEFAULT_FILTERS_VALUE) ? DEFAULT_FILTERS_VALUE : [],
			filtersInfo
		);
		onSubmit(req);
	};

	const removeFilterEle = () => {
		['grnId', 'poId'].forEach((key) => {
			if (key in state) {
				delete state[key];
			}
		});
		dispatch('SET_STATE', state);
	};

	useEffect(() => {
		if (props.selectedLppId) {
			const longTermPlan = longTermPlans?.find(
				(ele) => ele?.id === props.selectedLppId
			);
			dispatch({
				type: 'SET_LONG_TERM_PLAN',
				payload: {
					id: props.selectedLppId,
					name: longTermPlan?.name || '',
				},
			});
			handleSubmit();
		} else if (props.selectedLppId === null && longtermSingleSelect?.id) {
			dispatch({
				type: 'SET_LONG_TERM_PLAN',
				payload: null,
			});
		}
	}, [props.selectedLppId, longTermPlans]);

	useEffect(() => {
		if (update !== null && update > -1) {
			handleSubmit();
		}
	}, [update]);

	useEffect(() => {
		if (shouldAnimate) {
			const st = setTimeout(() => {
				setShouldAnimate(false);
			}, 1500);
			return () => {
				clearTimeout(st);
			};
		}
		return () => { };
	}, [shouldAnimate]);

	useEffect(() => {
		setShouldAnimate(true);
		setParentFilterState(state);
	}, [state, blink]);

	useEffect(() => {
		const objectKeys = Object.keys(defaultState);
		if (defaultState && objectKeys?.length) {
			objectKeys?.forEach((key) => {
				const defaultFilter = defaultState?.[key];
				if (key === 'STORE') {
					dispatch({
						type: 'SET_STORE',
						payload: defaultFilter,
					});
				}
				if (key === 'MULTI_STORE') {
					dispatch({
						type: 'SET_MULTI_STORE',
						payload: defaultFilter,
					});
				}
				if (key === 'GROUP') {
					dispatch({
						type: 'SET_GROUP',
						payload: defaultFilter,
					});
				}
				if (key === 'DATE_RANGE') {
					dispatch({
						type: 'SET_DATE_RANGE',
						payload: defaultFilter,
					});
				}
				if (key === 'STATUS') {
					dispatch({
						type: 'SET_STATUS',
						payload: defaultFilter,
					});
				}
				if (key === 'DATE_ONLY') {
					dispatch({
						type: 'SET_DATE_ONLY',
						payload: defaultFilter,
					});
				}
				if (key === 'VENDOR') {
					dispatch({
						type: 'SET_VENDORS',
						payload: defaultFilter,
					});
				}
				if (key === 'TIME_TYPE') {
					dispatch({
						type: 'SET_TIME_TYPE',
						payload: defaultFilter,
					});
				}
			});
		}
	}, [defaultState]);

	useEffect(() => {
		fetchBrands({
			id: '',
			allData: true,
		});

		if (
			filtersInfo['store']?.show ||
			filtersInfo['kitchenBaseStore']?.show ||
			filtersInfo['pods']?.show ||
			filtersInfo['raisedBy']?.show
		) {
			fetchStoresList({
				entity: 'STORES',
				req: {
					params: {
						id: '',
						type: storeTypes || '',
					},
				},
				method: 'LIST',
			});
		}
		if (filtersInfo?.group?.show) {
			fetchStoresList({
				entity: 'GROUPES',
				req: {
					params: {
						id: '',
						type: groupTypes || '',
					},
				},
				method: 'LIST',
			});
		}
	}, []);

	useEffect(() => {
		if (store !== EMPTYVALUE || filtersInfo?.allProcessType?.show) {
			fetchNodes();
		}
	}, [store, filtersInfo?.allProcessType?.show]);

	useEffect(() => {
		if (filtersInfo?.shift?.show) {
			fetchShifts();
		}
	}, [deliverFrom?.id, filtersInfo?.shift?.show]);

	const selectVendor = (id) => {
		const vendor = VENDORS?.filter((ele) => id.includes(ele?.id))?.map(
			(ele) => ele?.title
		);
		dispatch({
			type: 'SET_VENDORS',
			payload: {
				id: id,
				name: vendor,
			},
		});
	};
	const selectVendorSingle = (id) => {
		const vendor = VENDORS?.find((ele) => ele?.id === id);
		dispatch({
			type: 'SET_VENDOR',
			payload: {
				id: id,
				name: vendor?.title,
			},
		});
	};
	const selectProduct = (id) => {
		const product = PRODUCTS?.filter((ele) => id.includes(ele?.id))?.map(
			(ele) => ele?.title
		);
		dispatch({
			type: 'SET_PRODUCTS',
			payload: {
				id: id,
				name: product,
			},
		});
	};

	const selectProductSingle = (id) => {
		const product = PRODUCTS?.find((ele) => ele?.id === id);
		dispatch({
			type: 'SET_PRODUCT',
			payload: {
				id: id,
				name: product?.title,
			},
		});
	};

	// const selectProductWithVariant = (currentNode, values) => {
	// 	console.log(currentNode, values, 'productWithVariant');
	// 	let productData = [...productWithVariant?.productData];
	// 	const isParent = !currentNode?.parent;
	// 	const productId = isParent ? currentNode?.value : currentNode?.parent?.value;
	// 	const variantIds = isParent
	// 		? currentNode?.children?.map((item) => item?.value)
	// 		: [currentNode?.value];

	// 	if (currentNode.check === false) {
	// 		productData = productData.map((item) => {
	// 			if (item.productId === productId) {
	// 				const updatedVariants = item.variantIds.filter(id => !variantIds.includes(id));
	// 				return {
	// 					...item,
	// 					variantIds: updatedVariants,
	// 				};
	// 			}
	// 			return item;
	// 		}).filter(item => item.variantIds.length > 0);
	// 	} else {
	// 		const existing = productData.find(item => item.productId === productId);

	// 		if (existing) {
	// 			productData = productData.map((item) => {
	// 				if (item.productId === productId) {
	// 					const merged = [...new Set([...item.variantIds, ...variantIds])];
	// 					return {
	// 						...item,
	// 						variantIds: merged,
	// 					};
	// 				}
	// 				return item;
	// 			});
	// 		} else {
	// 			productData.push({
	// 				productId: productId,
	// 				variantIds: variantIds,
	// 			});
	// 		}
	// 	}

	// 	const labels = productData?.flatMap((item) => {
	// 		const product = productsList?.find(p => p.id === item.productId);
	// 		if (!product) return [];
	// 		const allVariantIds = product?.variants?.map(v => v.id);
	// 		const isAllSelected = allVariantIds?.every(id => item.variantIds.includes(id));
	// 		if (isAllSelected) {
	// 			return [product?.productName];
	// 		} else {
	// 			return product.variants
	// 				.filter(v => item.variantIds.includes(v.id))
	// 				.map(v => `${product.productName} - ${v.displayName}`);
	// 		}
	// 	});
	// 	dispatch({
	// 		type: 'SET_PRODUCT_WITH_VARIANTS',
	// 		payload: { productData, values, labels },
	// 	});
	// };

	const handleProductChange = (values) => {
		// Clear all
		if (!values || values.length === 0) {
			dispatch({
				type: 'SET_PRODUCT_WITH_VARIANTS',
				payload: {
					productData: [],
					values: [],
					labels: [],
				},
			});
			return;
		}

		// Build productData from values
		const productDataMap = new Map();

		values.forEach((valueId) => {
			// Find if this is a parent or child
			const parentProduct = productWithVariants.find(
				(p) => p.value === valueId
			);

			if (parentProduct && parentProduct.children) {
				// It's a parent - add all children
				const variantIds = parentProduct.children.map((c) => c.value);
				productDataMap.set(valueId, {
					productId: valueId,
					variantIds: variantIds,
				});
			} else {
				// It's a child - find parent
				const parent = productWithVariants.find((p) =>
					p.children?.some((c) => c.value === valueId)
				);

				if (parent) {
					if (productDataMap.has(parent.value)) {
						// Add to existing
						productDataMap
							.get(parent.value)
							.variantIds.push(valueId);
					} else {
						// Create new entry
						productDataMap.set(parent.value, {
							productId: parent.value,
							variantIds: [valueId],
						});
					}
				}
			}
		});

		const productData = Array.from(productDataMap.values());

		// Calculate labels
		const labels = productData.flatMap((item) => {
			const product = productsList?.find((p) => p.id === item.productId);
			if (!product) return [];

			const allVariantIds = product?.variants?.map((v) => v.id);
			const isAllSelected = allVariantIds?.every((id) =>
				item.variantIds.includes(id)
			);

			if (isAllSelected) {
				return [product?.productName];
			} else {
				return product.variants
					.filter((v) => item.variantIds.includes(v.id))
					.map((v) => `${product.productName} - ${v.displayName}`);
			}
		});

		dispatch({
			type: 'SET_PRODUCT_WITH_VARIANTS',
			payload: { productData, values, labels },
		});
	};

	const selectProductCategory = (id) => {
		const productCategory = PRODUCT_CATEGORIES?.filter((ele) =>
			id.includes(ele?.id)
		)?.map((ele) => ele?.title);
		dispatch({
			type: 'SET_PRODUCT_CATEGORY',
			payload: {
				id: id,
				name: productCategory,
			},
		});
	};

	const selectProductCategorySingle = (id) => {
		const productCategory = PRODUCT_CATEGORIES?.find(
			(ele) => ele?.id === id
		);
		dispatch({
			type: 'SET_PRODUCT_CATEGORY_SINGLE',
			payload: {
				id: id,
				name: productCategory?.title,
			},
		});
	};

	const selectDefects = (id) => {
		const defect = DEFECTS?.filter((ele) => id.includes(ele?.id))?.map(
			(ele) => ele?.title
		);
		dispatch({
			type: 'SET_DEFECTS',
			payload: {
				id: id,
				name: defect,
			},
		});
	};

	const selectSkuType = (type) => {
		dispatch({
			type: 'SET_SKU_TYPE',
			payload: type,
		});
	};

	const selectSkuTypeMulti = (types) => {
		dispatch({
			type: 'SET_SKU_TYPE_MULTI',
			payload: types,
		});
	};

	const selectIdentificationType = (type) => {
		dispatch({
			type: 'SET_IDENTIFICATION_TYPE',
			payload: type,
		});
	};

	const selectTabType = (type) => {
		dispatch({
			type: 'SET_TAB',
			payload: type,
		});
	};

	const selectMealType = (id) => {
		dispatch({
			type: 'SET_MEAL_TYPE',
			payload: id,
		});
	};

	const selectMealTypeMulti = (id) => {
		dispatch({
			type: 'SET_MEAL_TYPE_MULTI',
			payload: id,
		});
	};

	const selectStore = (id) => {
		const store = STORES?.find((ele) => ele?.id === id);
		dispatch({
			type: 'SET_STORE',
			payload: {
				id: id,
				name: store?.title,
			},
		});
	};
	const selectFromPod = (id) => {
		dispatch({
			type: 'SET_FROM_POD',
			payload: {
				id: id,
				name: FROMPODSTORES?.find((ele) => ele?.id === id)?.title,
			},
		});
	};
	const selectDeliverFrom = (id) => {
		const deliverFrom = STORES?.find((ele) => ele?.id === id);
		const selectedNavRequisite = stores?.find((ele) => ele?.id === id);
		const entry = Object.entries(navState)?.find(([_, value]) =>
			Object.keys(value?.submenu || {}).includes(currentPath[1])
		);
		const navKey = entry?.[0];
		const newRequisite = entry?.[1]?.requisites?.map((ele) => {
			if (ele?.type === 'store') {
				return {
					...ele,
					value: selectedNavRequisite,
				};
			}
			return ele;
		});
		dispatch({
			type: 'SET_DELIVER_FROM',
			payload: {
				id: id,
				name: deliverFrom?.title,
			},
		});
		reduxDispatch(
			navigationActions?.handleNavRequisite(
				navKey,
				newRequisite,
				null,
				location?.pathname
			)
		);
	};

	const selectFilterStoreMulti = (id) => {
		const store = STORES?.filter((ele) => id.includes(ele?.id))?.map(
			(ele) => ele?.title
		);
		dispatch({
			type: 'SET_FILTER_MULTI_STORE',
			payload: {
				id: id,
				name: store,
			},
		});
	};

	const selectStoreMulti = (id) => {
		const store = STORES?.filter((ele) => id.includes(ele?.id))?.map(
			(ele) => ele?.title
		);
		dispatch({
			type: 'SET_MULTI_STORE',
			payload: {
				id: id,
				name: store,
			},
		});
	};

	const selectToPod = (id) => {
		dispatch({
			type: 'SET_TO_POD',
			payload: {
				id: id,
				name: TOPODSTORES?.find((ele) => ele?.id === id)?.title,
			},
		});
	};
	const selectGroup = (id) => {
		const group = GROUPS?.find((ele) => ele?.id === id);
		dispatch({
			type: 'SET_GROUP',
			payload: {
				id: id,
				name: group?.title,
			},
		});
		dispatch({
			type: 'SET_PRODUCT_EXCLUSIVE',
			payload: null,
		});
	};

	const selectRegion = (id) => {
		const region = REGIONS?.find((ele) => ele?.id === id);
		dispatch({
			type: 'SET_REGION',
			payload: {
				id: id,
				name: region?.title,
			},
		});
	};

	const selectProductExclusive = (id) => {
		const product = PRODUCTS?.find((ele) => ele?.id === id);
		dispatch({
			type: 'SET_PRODUCT_EXCLUSIVE',
			payload: {
				id: id,
				name: product?.title,
			},
		});
		dispatch({
			type: 'SET_GROUP',
			payload: null,
		});
	};

	// Dedicated ingredient picker (separate state from productExclusive so the
	// two filters don't trample each other when both are configured).
	const selectIngredient = (id) => {
		const item = (productsList ?? []).find((ele) => ele?.id === id);
		dispatch({
			type: 'SET_INGREDIENT',
			payload: id == null
				? null
				: {
					id,
					name: item?.productName ?? item?.name ?? '',
				},
		});
	};
	const selectStatus = (statusEle) => {
		dispatch({
			type: 'SET_STATUS',
			payload: statusEle,
		});
	};
	const selectRaisedByStore = (id) => {
		const raisedByStore = STORES?.find((ele) => ele?.id === id);
		dispatch({
			type: 'SET_RAISED_BY_STORE',
			payload: {
				id: id,
				name: raisedByStore?.title,
			},
		});
	};
	const selectProcessType = (id) => {
		dispatch({
			type: 'SET_PROCESS_TYPE',
			payload: {
				id: id,
				name: PROCESS_TYPES?.find((ele) =>
					Array.isArray(id)
						? id.includes(ele?.id)
						: Number(id) === Number(ele?.id)
				)?.title,
			},
		});
	};
	const setFromProcess = (ids) => {
		dispatch({
			type: 'SET_FROM_PROCESS',
			payload: {
				id: ids ?? [],
				name: PROCESS_TYPES?.filter((ele) =>
					ids?.includes(ele?.id)
				)?.map((ele) => ele?.title),
			},
		});
	};
	const setFromProcessSingle = (id) => {
		dispatch({
			type: 'SET_FROM_PROCESS',
			payload: {
				id,
				name: PROCESS_TYPES?.find((ele) => ele?.id === id)?.title,
			},
		});
	};
	const setToProcess = (ids) => {
		dispatch({
			type: 'SET_TO_PROCESS',
			payload: {
				id: ids ?? [],
				name: PROCESS_TYPES?.filter((ele) =>
					ids?.includes(ele?.id)
				)?.map((ele) => ele?.title),
			},
		});
	};
	const setToProcessSingle = (id) => {
		dispatch({
			type: 'SET_TO_PROCESS',
			payload: {
				id,
				name: PROCESS_TYPES?.find((ele) => ele?.id === id)?.title,
			},
		});
	};
	const setPage = (page) => {
		dispatch({
			type: 'SET_PAGE',
			payload: page,
		});
	};
	const selectType = (id) => {
		dispatch({
			type: 'SET_FEATURE_TYPE',
			payload: id,
		});
	};

	const selectProductionPlan = (value) => {
		const productionPlan = productionPlans
			?.filter((ele) => value?.includes(ele?.id))
			?.map((ele) => ele?.description);
		dispatch({
			type: 'SET_PRODUCTION_PLAN',
			payload: {
				id: value,
				name: productionPlan,
			},
		});
	};

	const selectAllProcessType = (value) => {
		const processType = ALL_PROCESS_TYPES?.find((ele) => ele?.id === value);
		dispatch({
			type: 'SET_ALL_PROCESS_TYPE',
			payload: {
				id: value,
				name: processType?.title,
			},
		});
	};

	const selectAllProcessTypeMulti = (value) => {
		const processType = ALL_PROCESS_TYPES?.filter((ele) =>
			value?.includes(ele?.id)
		)?.map((ele) => ele?.title);
		dispatch({
			type: 'SET_ALL_PROCESS_TYPE_MULTI',
			payload: {
				id: value,
				name: processType,
			},
		});
	};

	const selectLongTermPlanMulti = (value) => {
		const longTermPlan = longTermPlans
			?.filter((ele) => value?.includes(ele?.id))
			?.map((ele) => ele?.name);
		dispatch({
			type: 'SET_LONG_TERM_PLAN_MULTI',
			payload: {
				id: value,
				name: longTermPlan,
			},
		});
	};

	const selectLongTermPlan = (value) => {
		const longTermPlan = longTermPlans?.find((ele) => ele?.id === value);
		dispatch({
			type: 'SET_LONG_TERM_PLAN',
			payload: {
				id: value,
				name: longTermPlan?.name,
			},
		});
	};
	const selectConfidence = (value) => {
		dispatch({
			type: 'SET_CONFIDENCE',
			payload: value,
		});
	};

	const selectproductionPlanStatus = (value) => {
		dispatch({
			type: 'SET_PRODUCTION_PLAN_GENERATED',
			payload: value,
		});
	};

	// 'All' first, then the store's shifts as they came back from the backend. A null
	// value is what the request builders read as "do not filter on shift".
	const shiftOptions = useMemo(() => {
		return [
			{ label: 'All', value: null },
			...(shifts ?? []).map((ele) => {
				return { label: ele?.shiftName, value: ele?.id };
			}),
		];
	}, [shifts]);

	const selectShift = (value) => {
		const selectedShift = shiftOptions?.find((ele) => {
			return ele?.value === value;
		});
		dispatch({
			type: 'SET_SHIFT',
			payload: {
				id: value ?? null,
				name: selectedShift?.label ?? '',
			},
		});
	};

	const selectCustomExclusiveFilters = (value) => {
		const name = filtersInfo?.customExclusiveFilters?.filterList
			?.filter((ele) => value?.includes(ele?.value))
			?.map((ele) => ele?.label);
		dispatch({
			type: 'SET_CUSTOM_EXCLUSIVE_FILTER',
			payload: {
				id: value,
				name: name,
			},
		});
	};

	const singleSelectCustomExclusiveFilters = (value) => {
		const filterValue = filtersInfo[
			'customExclusiveFilters'
		]?.filterList?.find((ele) => ele?.value === value)?.label;
		dispatch({
			type: 'SET_CUSTOM_EXCLUSIVE_FILTER',
			payload: {
				id: value,
				name: filterValue,
			},
		});
	};

	const brandsList = useMemo(() => {
		return [
			...Object.keys(brands).map((id) => {
				const currBrand = brands[id];
				return currBrand;
			}),
		];
	}, [brands]);

	useEffect(() => {
		if (timeTypeArray && timeTypeArray.length > 0) {
			dispatch({
				type: 'SET_TIME_TYPE',
				payload: {
					value: timeTypeArray[0].value,
					label: timeTypeArray[0].label,
				},
			});
		}
	}, [timeTypeArray]);

	// const settingNavSelectedStore = useMemo(() => {
	// 	dispatch({
	// 		type: 'SET_DELIVER_FROM',
	// 		payload: {
	// 			id: navSelectedStore?.value?.id,
	// 			name: navSelectedStore?.value?.title,
	// 		},
	// 	});
	// }, [navSelectedStore]);

	useEffect(() => {
		dispatch({
			type: 'SET_ORDER_TYPE',
			payload: tabType,
		});
	}, [tabType]);

	useEffect(() => {
		if (
			filtersInfo['product']?.show ||
			filtersInfo['productExclusive']?.show ||
			filtersInfo['productWithVariants']?.show
		) {
			fetchProducts({
				entity: 'ALL_PRODUCTS',
				req: {
					params: {
						id: '',
						brandId: brandsList[0]?.id ? brandsList[0]?.id : '',
						variants: true,
					},
				},
				method: 'LIST',
			});
		}
		if (filtersInfo['features']?.show) {
			fetchDefects({
				entity: 'DEFECTS',
				req: {
					params: {
						brandId: brandsList[0]?.id ? brandsList[0]?.id : '',
					},
				},
				method: 'LIST',
			});
		}
	}, [brandsList[0]?.id, filtersInfo['vendor']?.show]);

	const VENDORS = useMemo(() => {
		return (
			(filtersInfo['vendor']?.show ? vendorsList : buyersList) ?? []
		)?.map((vendor) => {
			return {
				id: vendor.id,
				title: vendor?.name ?? '',
			};
		});
	}, [vendorsList, buyersList, filtersInfo['vendor']?.show]);

	const STORES = useMemo(() => {
		const tempStore = stores?.map((tStore) => {
			return {
				id: tStore.id,
				title: tStore?.name ?? '',
				type: tStore?.type,
			};
		});
		if (allStoreOption) {
			tempStore?.unshift({
				id: EMPTYVALUE,
				title: 'ALL',
				type: 'ALL',
			});
		}
		return tempStore;
	}, [stores, allStoreOption]);

	const PERMITTEDSTORES = useMemo(() => {
		const tempStore = permittedStores?.map((tStore) => {
			return {
				id: tStore.id,
				title: tStore?.name ?? '',
				type: tStore?.storeType,
			};
		});
		if (allStoreOption) {
			tempStore?.unshift({
				id: EMPTYVALUE,
				title: 'ALL',
				type: 'ALL',
			});
		}
		return tempStore;
	}, [permittedStores, allStoreOption]);

	const FROMPODSTORES = useMemo(() => {
		const allowedTypes = filtersInfo?.kitchenBaseStore?.types;
		const hasTypeList = Array.isArray(allowedTypes) && allowedTypes.length > 0;
		const tempStore = stores
			?.filter((ele) => (hasTypeList
				? allowedTypes.includes(ele?.type)
				: ele?.type === 'BASE'))
			.map((item) => {
				return {
					id: item.id,
					title: item?.name ?? '',
					type: item?.type,
				};
			});
		return tempStore;
	}, [stores, filtersInfo?.kitchenBaseStore?.types]);

	// The store list arrives after mount, so the first kitchen can only be filled
	// in once FROMPODSTORES is populated - and the page is re-queried with it so
	// the screen is never left showing the un-scoped result of the initial call.
	// The ref keeps this to that one initial fill; what the user picks afterwards
	// (including nothing, if the picker is cleanable) is left alone.
	useEffect(() => {
		if (!isKitchenMandatory || defaultKitchenAppliedRef.current) {
			return;
		}
		if (fromPod?.id) {
			defaultKitchenAppliedRef.current = true;
			return;
		}
		const firstKitchen = FROMPODSTORES?.[0];
		if (!firstKitchen?.id) {
			return;
		}
		defaultKitchenAppliedRef.current = true;
		const payload = {
			id: firstKitchen?.id,
			name: firstKitchen?.title,
		};
		dispatch({
			type: 'SET_FROM_POD',
			payload,
		});
		// Spread the current state the way the initial mount call does, so anything
		// already picked (date range, time type, ...) rides along with the kitchen.
		handleSubmitParams({ ...state, fromPod: payload });
	}, [FROMPODSTORES, fromPod?.id, isKitchenMandatory]);

	const TOPODSTORES = useMemo(() => {
		const tempStore = stores
			?.filter((ele) => ele?.type === 'RETAIL')
			.map((item) => {
				return {
					id: item.id,
					title: item?.name ?? '',
					type: item?.type,
				};
			});
		if (allStoreOption) {
			tempStore?.unshift({
				id: EMPTYVALUE,
				title: 'ALL',
				type: 'ALL',
			});
		}
		return tempStore;
	}, [stores, allStoreOption]);

	const FILTEREDSTORES = useMemo(() => {
		const validStores = {};
		(permittedStores || []).forEach((validStoreLoop) => {
			validStores[validStoreLoop.id] = true;
		});
		const tempStore = stores
			?.filter((storeFilter) => {
				return (
					permittedStores?.length === 0 ||
					validStores?.[storeFilter?.id]
				);
			})
			?.map((tStore) => {
				return {
					id: tStore.id,
					title: tStore?.name ?? '',
					type: tStore?.type,
				};
			});
		if (allStoreOption) {
			tempStore?.unshift({
				id: EMPTYVALUE,
				title: 'ALL',
				type: 'ALL',
			});
		}
		return tempStore;
	}, [stores, permittedStores, allStoreOption]);

	const GROUPS = useMemo(() => {
		const tempGroup = groups?.map((tGroup) => {
			return {
				id: tGroup.groupId,
				title: tGroup?.groupName ?? '',
			};
		});

		return tempGroup;
	}, [groups]);

	const REGIONS = useMemo(() => {
		const tempRegion = regions?.map((tregion) => {
			return {
				id: tregion.regionId,
				title: tregion?.regionName ?? '',
			};
		});

		return tempRegion;
	}, [regions]);

	useEffect(() => {
		if (filtersInfo['productCategory']?.show) {
			fetchProductCategoriesList({
				entity: 'PRODUCT_CATEGORY',
				req: {
					params: {
						id: '',
					},
				},
				method: 'LIST',
			});
		}
		if (filtersInfo['imagesType']?.show) {
			dispatch({
				type: 'SET_IMAGES_TYPE',
				payload: POSSIBLE_IMAGE_TYPES?.[0]?.id,
			});
		}
	}, []);

	useEffect(() => {
		if (filtersInfo['productCategory']?.show) {
			fetchProductCategoriesList({
				entity: 'PRODUCT_CATEGORY',
				req: {
					params: {
						id: '',
					},
				},
				method: 'LIST',
			});
		}
		if (filtersInfo['vendor']?.show || filtersInfo['buyer']?.show) {
			const type = filtersInfo['buyer']?.show ? 'BUYER' : 'VENDOR';
			fetchAllVendors({
				entity: type === 'BUYER' ? 'ALL_BUYERS' : 'ALL_VENDORS',
				req: {
					params: {
						id: '',
					},
				},
				type,
				method: 'LIST',
			});
		}
		if (filtersInfo['imagesType']?.show) {
			dispatch({
				type: 'SET_IMAGES_TYPE',
				payload: POSSIBLE_IMAGE_TYPES?.[0]?.id,
			});
		}
	}, []);

	const PRODUCTS = useMemo(() => {
		let filteredProduct = productsList;
		if (filtersInfo['buyer']?.show || filtersInfo['product']?.skuType) {
			const targetSkuType = typeof filtersInfo['product']?.skuType === 'string' ? filtersInfo['product']?.skuType : 'PRODUCT';
			filteredProduct = productsList?.filter(
				(product) => product?.skuType === targetSkuType
			);
		}
		return filteredProduct?.map((product) => {
			return {
				id: product?.id,
				title: product?.productName ?? '',
			};
		});
	}, [productsList, filtersInfo['buyer']?.show, filtersInfo['product']?.skuType]);

	const PRODUCT_EXCLUSIVE_PRODUCTS = useMemo(() => {
		const exclusiveSkuType = filtersInfo['productExclusive']?.skuType;
		const filteredProduct = exclusiveSkuType
			? productsList?.filter(
				(product) => product?.skuType === exclusiveSkuType
			)
			: productsList;
		return filteredProduct?.map((product) => {
			return {
				id: product?.id,
				title: product?.productName ?? '',
			};
		});
	}, [productsList, filtersInfo['productExclusive']?.skuType]);

	// Source for the new ingredient picker (defaults to skuType: 'INGREDIENT'
	// when the caller doesn't override it).
	const INGREDIENT_PRODUCTS = useMemo(() => {
		const ingredientSkuType = filtersInfo['ingredient']?.skuType ?? 'INGREDIENT';
		const filteredProduct = ingredientSkuType
			? productsList?.filter(
				(product) => product?.skuType === ingredientSkuType
			)
			: productsList;
		return filteredProduct?.map((product) => {
			return {
				id: product?.id,
				title: product?.productName ?? '',
			};
		});
	}, [productsList, filtersInfo['ingredient']?.skuType]);

	const productWithVariants = useMemo(() => {
		const list = (productsList || [])?.map((item) => {
			const children = item?.variants?.map((variant) => {
				return {
					label: `${item?.productName}(${variant?.displayName})`,
					value: variant?.id,
				};
			});
			return {
				label: item?.productName,
				value: item?.id,
				children: children,
			};
		});
		return list;
	}, [productsList, filtersInfo['buyer']?.show]);

	const filteredProductsForTree = useMemo(() => {
		const INITIAL_LIMIT = 100;
		const searchTerm = productTreeSearch?.toLowerCase()?.trim();

		if (!productWithVariants || !Array.isArray(productWithVariants)) {
			return [];
		}

		if (searchTerm && searchTerm.length >= 2) {
			const filtered = productWithVariants.filter((item) => {
				const labelMatch = item?.label
					?.toLowerCase()
					?.includes(searchTerm);
				const childrenMatch = item?.children?.some((child) =>
					child?.label?.toLowerCase()?.includes(searchTerm)
				);
				return labelMatch || childrenMatch;
			});
			return filtered.slice(0, 200);
		}

		return productWithVariants.slice(0, INITIAL_LIMIT);
	}, [productWithVariants, productTreeSearch]);

	const PRODUCT_CATEGORIES = useMemo(() => {
		return productCategoriesList
			?.filter((category) => {
				if (
					brandsList?.length === 0 ||
					brandsList?.[0]?.id === EMPTYVALUE
				)
					return category;
				return category?.brandId === brandsList?.[0]?.id;
			})
			?.map((category) => {
				return {
					id: category?.id,
					title: category?.productCategoryName ?? '',
				};
			});
	}, [productCategoriesList, brandsList]);

	const DEFECTS = useMemo(() => {
		return defectsList?.map((defect) => {
			return {
				id: defect?.id,
				title: defect?.label ?? '',
			};
		});
	}, [defectsList]);

	useEffect(() => {
		dispatch({
			type: 'SET_IDENTIFICATION_TYPE',
			payload: 'Both',
		});
	}, []);

	useEffect(() => {
		dispatch({
			type: 'SET_BRAND',
			payload: {
				id: brandsList?.[0]?.id,
				name: brandsList?.[0]?.name,
			},
		});
	}, [brandsList]);

	const selectBrand = (value) => {
		dispatch({
			type: 'SET_BRAND',
			payload: {
				id: value,
				name: brandsList?.find((item) => item.id === value)?.name,
			},
		});
	};

	const dateRangeFilterArray = useMemo(() => {
		return [
			{
				startDate: dateRange?.from,
				endDate: dateRange?.to,
				key: 'selection',
			},
		];
	}, [dateRange]);

	const setDateRange = ({ active, from, to }) => {
		dispatch({
			type: 'SET_DATE_RANGE',
			payload: {
				active,
				from,
				to,
			},
		});
	};

	const setDateOnly = ({ active, date }) => {
		dispatch({
			type: 'SET_DATE_ONLY',
			payload: {
				active,
				date,
			},
		});
	};

	useEffect(() => {
		if (preventDateRangeCheckbox) {
			setDateRange({
				...dateRange,
				active: true,
			});
		}
	}, [preventDateRangeCheckbox]);

	const setDate = (newDate) => {
		const { startDate: from, endDate: to } = newDate?.selection ?? {};

		setDateRange({
			active: true,
			from,
			to,
		});
	};

	const handleDateRangeChange = (newDate) => {
		if (!newDate) {
			setDateRange({
				active: false,
				from: null,
				to: null,
			});
		}
	};

	const selectImagesType = (id) => {
		dispatch({
			type: 'SET_IMAGES_TYPE',
			payload: id,
		});
	};
	const handleEgaPercentage = (e) => {
		setEgaPercentage({
			...egaPercentage,
			checked: e.target.checked,
		});
	};

	const selectTimeType = (e) => {
		const { fieldValue } = inputHelper(e);
		const selectedType = (timeTypeArray ?? defaultTimeTypeArr).find(
			(type) => type.value === fieldValue
		);

		dispatch({
			type: 'SET_TIME_TYPE',
			payload: {
				value: fieldValue,
				label: selectedType?.label,
				disabledFutureDate: selectedType?.disabledFutureDate ?? false,
			},
		});
	};

	const selectExportType = (value) => {
		dispatch({
			type: 'SET_EXPORT_TYPE',
			payload: value,
		});
	};

	const handleExportFilter = () => {
		const req = config?.deserializer(
			{
				store:
					store?.id === EMPTYVALUE ? { ...store, id: null } : store,
				multiStore:
					multiStore?.id === EMPTYVALUE
						? { ...multiStore, id: null }
						: multiStore,
				filterMultiStore:
					filterMultiStore?.id === EMPTYVALUE
						? { ...filterMultiStore, id: null }
						: filterMultiStore,
				fromPod:
					data?.fromPod?.id === EMPTYVALUE
						? { ...data?.fromPod, id: null }
						: data?.fromPod ??
						(fromPod?.id === EMPTYVALUE
							? { ...fromPod, id: null }
							: fromPod),
				toPod:
					data?.toPod?.id === EMPTYVALUE
						? { ...data?.toPod, id: null }
						: data?.toPod ??
						(toPod?.id === EMPTYVALUE
							? { ...toPod, id: null }
							: toPod),
				group:
					group?.id === EMPTYVALUE ? { ...group, id: null } : group,
				region:
					region?.id === EMPTYVALUE
						? { ...region, id: null }
						: region,
				productExclusive:
					productExclusive?.id === EMPTYVALUE
						? { ...productExclusive, id: null }
						: productExclusive,
				ingredient:
					ingredient?.id === EMPTYVALUE
						? { ...ingredient, id: null }
						: ingredient,
				processTypes:
					processType?.id === EMPTYVALUE
						? { ...processType, id: null }
						: processType,
				vendors,
				products,
				product:
					product?.id === EMPTYVALUE
						? { ...product, id: null }
						: product,
				productWithVariant,
				brand,
				imagesType: POSSIBLE_IMAGE_TYPES?.find((ele) => {
					return ele?.id === imagesType;
				})?.returnValue,
				productCategories,
				productCategory,
				identificationType,
				featureType,
				conf: {
					minConf: Math.min(sliderValue[0], sliderValue[1]),
					maxConf: Math.max(sliderValue[0], sliderValue[1]),
				},
				egaPercentage,
				timeType,
				pageLimit,
				dateRange,
				dateOnly,
				status,
				type: type === 'Select Type' ? null : type,
				deliverFrom:
					deliverFrom?.id === EMPTYVALUE
						? { ...deliverFrom, id: null }
						: deliverFrom,
				customExclusiveFilters: state?.customExclusiveFilters,
				paymentType,
				paymentStatus,
				productionPlan,
				orderType,
				exportType,
				skuType,
				allProcessType,
				allProcessTypeMulti,
				mealType,
				mealTypeMulti,
				longtermMultiSelect,
				longtermSingleSelect,
			},
			isInternal,
			Array.isArray(DEFAULT_FILTERS_VALUE) ? DEFAULT_FILTERS_VALUE : [],
			filtersInfo
		);
		handleDataExport(req);
	};

	const PROCESS_TYPES = useMemo(() => {
		const types = (processTypes ?? [])?.map((ele) => {
			return {
				id: ele?.id,
				title: `${ele?.data?.heading}${ele?.storeName ? ' ' + ele.storeName : ''
					}`,
			};
		});
		return types;
	}, [processTypes]);

	const ALL_PROCESS_TYPES = useMemo(() => {
		return processTypes
			?.filter((ele) => {
				return ele?.data?.totalMachines > 0;
			})
			?.map((ele) => {
				return {
					id: ele?.id,
					title: `${ele?.data?.heading}${ele?.storeName ? ' ' + ele.storeName : ''
						}`,
				};
			});
	}, [processTypes]);

	useEffect(() => {
		if (store === EMPTYVALUE) {
			dispatch({
				type: 'SET_PROCESS_TYPE',
				payload: null,
			});
			dispatch({
				type: 'SET_FROM_PROCESS',
				payload: null,
			});
			dispatch({
				type: 'SET_TO_PROCESS',
				payload: null,
			});
		}
	}, [PROCESS_TYPES, store]);

	useEffect(() => {
		dispatch({
			type: 'SET_DELIVER_FROM',
			payload: {
				id: navSelectedStore?.value?.id,
				name: navSelectedStore?.value?.name,
			},
		});
	}, [navSelectedStore?.value?.id]);
	// export button render
	// const renderBtns = () => {
	// 	if (!exportToggle) return null;

	// 	return (
	// 		<Button
	// 			className='text-black rounded-md bg-yellow-500 flex flex-row justify-end items-center gap-2'
	// 			onClick={handleExport}
	// 		>
	// 			<Upload size={16}/>
	// 			<span className='font-bold normal-case'>Export (.csv)</span>
	// 		</Button>
	// 	);
	// };

	useEffect(() => {
		dispatch({
			type: 'SET_EXPORT_TYPE',
			payload: exportInfo?.exportTypes?.[0]?.value,
		});
	}, [exportInfo?.showDropDown]);

	const filterData = [
		{
			title: 'store',
			isDisabled: filtersInfo['header']?.store !== false,
			panel: (
				<Accordion.Panel
					className='overflow-visible border-b border-[#00000033] rounded-none'
					header={<Header title='Store' icon={<Store />} />}
					defaultExpanded={filtersInfo['header']?.store === false}
					disabled={filtersInfo['header']?.store !== false}
					caretAs={
						filtersInfo['header']?.store !== false
							? () => {
								return <Ban size={16} />;
							}
							: () => {
								return <ArrowDropDown size={16} />;
							}
					}
				>
					<div className='flex flex-col gap-3 items-start w-full'>
						{filtersInfo['deliverFrom']?.show && (
							<div className='flex flex-col m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['deliverFrom']?.text ||
										'Deliver From'}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										data={PERMITTEDSTORES?.map((ele) => {
											return {
												...ele,
												label: ele?.title,
												role: ele?.storeType,
												value: ele?.id,
											};
										})}
										className='w-[325px] select-picker-custom'
										groupBy='type'
										placeholder={
											filterLabels?.deliverFrom ??
											'Select Store'
										}
										onChange={selectDeliverFrom}
										renderMenuItem={(_) => {
											return (
												<div>
													<i className='rs-icon rs-icon-user' />{' '}
													{_}
												</div>
											);
										}}
										renderMenuGroup={(_) => {
											return (
												<div>
													<i className='rs-icon rs-icon-group' />{' '}
													{_}
												</div>
											);
										}}
										cleanable={false}
										value={deliverFrom?.id}
										renderValue={(_, item) => {
											return (
												<div
													className={`${styles.selected_store} rsuite-select-picker-render-value`}
												>
													<p className='text-[12px]'>
														{filterLabels?.deliverFrom ??
															'Store:'}{' '}
														{item?.title}
													</p>
												</div>
											);
										}}
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{/* store  */}
						{filtersInfo['store']?.show && (
							<div className='flex flex-col m-1 gap-2'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['store']?.text || 'Store'}
								</span>
								<div ref={containerRef} className='relative'>
									{filtersInfo['store']?.multiSelect ? (
										<CheckPicker
											data={
												filtersInfo['store']
													?.permittedStore
													? PERMITTEDSTORES?.map(
														(ele) => ({
															...ele,
															label: ele?.title,
															role: ele?.type,
															value: ele?.id,
														})
													)
													: filtersInfo['store']
														?.noAllOption
														? STORES?.map((ele) => ({
															...ele,
															label: ele?.title,
															role: ele?.type,
															value: ele?.id,
														})).filter(
															(ele) =>
																ele?.id !==
																EMPTYVALUE
														)
														: STORES?.map((ele) => ({
															...ele,
															label: ele?.title,
															role: ele?.type,
															value: ele?.id,
														}))
											}
											className='w-[325px] select-picker-custom'
											groupBy='type'
											placeholder={
												filterLabels?.store ??
												'Select Store'
											}
											onChange={selectStoreMulti}
											renderMenuItem={(_) => {
												return (
													<div>
														<i className='rs-icon rs-icon-user' />{' '}
														{_}
													</div>
												);
											}}
											renderMenuGroup={(_) => {
												return (
													<div>
														<i className='rs-icon rs-icon-group' />{' '}
														{_}
													</div>
												);
											}}
											cleanable={false}
											value={multiStore?.id}
											container={() =>
												containerRef.current
											}
										/>
									) : (
										<SelectPicker
											data={
												filtersInfo['store']
													?.permittedStore
													? PERMITTEDSTORES?.map(
														(ele) => ({
															...ele,
															label: ele?.title,
															role: ele?.type,
															value: ele?.id,
														})
													)
													: filtersInfo['store']
														?.noAllOption
														? STORES?.map((ele) => ({
															...ele,
															label: ele?.title,
															role: ele?.type,
															value: ele?.id,
														})).filter(
															(ele) =>
																ele?.id !==
																EMPTYVALUE
														)
														: STORES?.map((ele) => ({
															...ele,
															label: ele?.title,
															role: ele?.type,
															value: ele?.id,
														}))
											}
											className='w-[325px] select-picker-custom'
											groupBy='type'
											placeholder={
												filterLabels?.store ??
												'Select Store'
											}
											onChange={selectStore}
											renderMenuItem={(_) => {
												return (
													<div>
														<i className='rs-icon rs-icon-user' />{' '}
														{_}
													</div>
												);
											}}
											renderMenuGroup={(_) => {
												return (
													<div>
														<i className='rs-icon rs-icon-group' />{' '}
														{_}
													</div>
												);
											}}
											cleanable={false}
											value={store?.id}
											renderValue={(_, item) => {
												return (
													<div
														className={`${styles.selected_store} rsuite-select-picker-render-value`}
													>
														<p className='text-[12px]'>
															{filterLabels?.store ??
																'Store:'}{' '}
															{item?.title}
														</p>
													</div>
												);
											}}
											container={() =>
												containerRef.current
											}
										/>
									)}
								</div>
							</div>
						)}
						{/* shift  */}
						{filtersInfo['shift']?.show && (
							<div className='flex flex-col m-1 gap-2'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['shift']?.text || 'Shift'}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										data={shiftOptions}
										className='w-[325px] select-picker-custom'
										placeholder={
											filterLabels?.shift ?? 'Select Shift'
										}
										value={shift?.id ?? null}
										onChange={selectShift}
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{/* kitchen base store  */}
						{filtersInfo['kitchenBaseStore']?.show && (
							<div className='flex flex-col m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['kitchenBaseStore']?.text ||
										'Kitchen'}
									{isKitchenMandatory && (
										<span className='text-red-500'>*</span>
									)}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										data={FROMPODSTORES?.map((ele) => {
											return {
												...ele,
												label: ele?.title,
												role: ele?.type,
												value: ele?.id,
											};
										})}
										className='w-[325px] select-picker-custom'
										groupBy='type'
										placeholder={
											filterLabels?.fromPod ??
											'Select Kitchen *'
										}
										onChange={selectFromPod}
										renderMenuItem={(_) => {
											return (
												<div>
													<i className='rs-icon rs-icon-user' />{' '}
													{_}
												</div>
											);
										}}
										renderMenuGroup={(_) => {
											return (
												<div>
													<i className='rs-icon rs-icon-group' />{' '}
													{_}
												</div>
											);
										}}
										cleanable={cleanable?.fromPod ?? false}
										value={fromPod?.id}
										renderValue={(_, item) => {
											return (
												<div
													className={`${styles.selected_store} rsuite-select-picker-render-value`}
												>
													<p className='text-[12px]'>
														{filterLabels?.store ??
															'Kitchen:'}{' '}
														{item?.title}
													</p>
												</div>
											);
										}}
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{/* pods retail store */}
						{filtersInfo['pods']?.show && (
							<div className='flex flex-col m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['pods']?.text || 'Pods'}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										data={TOPODSTORES?.map((ele) => {
											return {
												...ele,
												label: ele?.title,
												role: ele?.type,
												value: ele?.id,
											};
										})}
										className='w-[325px] select-picker-custom'
										groupBy='type'
										placeholder={
											filterLabels?.toPod ?? 'Select Pods'
										}
										onChange={selectToPod}
										renderMenuItem={(_) => {
											return (
												<div>
													<i className='rs-icon rs-icon-user' />{' '}
													{_}
												</div>
											);
										}}
										renderMenuGroup={(_) => {
											return (
												<div>
													<i className='rs-icon rs-icon-group' />{' '}
													{_}
												</div>
											);
										}}
										cleanable={false}
										value={toPod?.id}
										renderValue={(_, item) => {
											return (
												<div
													className={`${styles.selected_store} rsuite-select-picker-render-value`}
												>
													<p className='text-[12px]'>
														{filterLabels?.store ??
															'Pods:'}{' '}
														{item?.title}
													</p>
												</div>
											);
										}}
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{/* filter store  */}
						{filtersInfo['filteredStore']?.show && (
							<div className='flex flex-col m-1 gap-2'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['filteredStore']?.text ||
										'Store'}
								</span>
								<div ref={containerRef} className='relative'>
									{filtersInfo['filteredStore']
										?.multiSelect ? (
										<CheckPicker
											data={FILTEREDSTORES?.map((ele) => {
												return {
													...ele,
													label: ele?.title,
													role: ele?.type,
													value: ele?.id,
												};
											})}
											className='w-[325px] select-picker-custom'
											groupBy='type'
											placeholder={
												filterLabels?.filteredStore ??
												'Select Store'
											}
											onChange={selectFilterStoreMulti}
											renderMenuItem={(_) => {
												return (
													<div>
														<i className='rs-icon rs-icon-user' />{' '}
														{_}
													</div>
												);
											}}
											renderMenuGroup={(_) => {
												return (
													<div>
														<i className='rs-icon rs-icon-group' />{' '}
														{_}
													</div>
												);
											}}
											value={filterMultiStore?.id}
											cleanable={false}
											container={() =>
												containerRef.current
											}
										/>
									) : (
										<SelectPicker
											data={FILTEREDSTORES?.map((ele) => {
												return {
													...ele,
													label: ele?.title,
													role: ele?.type,
													value: ele?.id,
												};
											})}
											className='w-[325px] select-picker-custom'
											groupBy='type'
											placeholder={
												filterLabels?.store ??
												'Select Store'
											}
											onChange={selectStore}
											renderMenuItem={(_) => {
												return (
													<div>
														<i className='rs-icon rs-icon-user' />{' '}
														{_}
													</div>
												);
											}}
											renderMenuGroup={(_) => {
												return (
													<div>
														<i className='rs-icon rs-icon-group' />{' '}
														{_}
													</div>
												);
											}}
											value={store?.id}
											cleanable={false}
											renderValue={(_, item) => {
												return (
													<div
														className={`${styles.selected_store} rsuite-select-picker-render-value`}
													>
														<p className='text-[12px]'>
															{filterLabels?.store ??
																'Store:'}{' '}
															{item?.title}
														</p>
													</div>
												);
											}}
											container={() =>
												containerRef.current
											}
										/>
									)}
								</div>
							</div>
						)}
						{(filtersInfo['vendor']?.show ||
							filtersInfo['buyer']?.show) && (
								<div className='flex flex-col m-1 gap-2 w-full'>
									<span className='text-slate-500 text-[12px]'>
										{filtersInfo['vendor']?.show
											? filtersInfo['vendor']?.text
											: filtersInfo['buyer']?.text}
									</span>
									<div
										className={classes(
											styles.filter,
											styles.vendor
										)}
									>
										<div
											ref={containerRef}
											className='relative'
										>
											{filtersInfo['vendor']?.singleSelect ||
												filtersInfo['buyer']?.singleSelect ? (
												<SelectPicker
													data={VENDORS?.map((ele) => {
														return {
															label: ele?.title,
															value: ele?.id,
														};
													})}
													className='w-[340px] select-picker-custom'
													container={() =>
														containerRef.current
													}
													value={vendor?.id}
													onChange={selectVendorSingle}
													placeholder={
														filtersInfo['vendor']?.show
															? 'Select Vendor(s)'
															: 'Select Buyer(s)'
													}
												/>
											) : (
												<CheckPicker
													data={VENDORS?.map((ele) => {
														return {
															label: ele?.title,
															value: ele?.id,
														};
													})}
													className='w-[340px] select-picker-custom'
													container={() =>
														containerRef.current
													}
													value={vendors?.id}
													onChange={selectVendor}
													placeholder={
														filtersInfo['vendor']?.show
															? 'Select Vendor(s)'
															: 'Select Buyer(s)'
													}
												/>
											)}
										</div>
									</div>
								</div>
							)}
					</div>
				</Accordion.Panel>
			),
		},
		{
			title: 'process',
			isDisabled: filtersInfo['header']?.process !== false,
			panel: (
				<Accordion.Panel
					className='overflow-visible border-b border-[#00000033]'
					header={<Header title='Process' icon={<Settings />} />}
					defaultExpanded={filtersInfo['header']?.process === false}
					disabled={filtersInfo['header']?.process !== false}
					caretAs={
						filtersInfo['header']?.process !== false
							? () => {
								return <Ban size={16} />;
							}
							: () => {
								return <ArrowDropDown size={16} />;
							}
					}
				>
					{filtersInfo['processType']?.show && (
						<div className='flex flex-col gap-1 items-start mb-3'>
							<span className='text-slate-500 text-[12px]'>
								Process Type
								{filtersInfo['processType']?.mandatory ? ' *' : ''}
							</span>
							<div ref={containerRef} className='relative'>
								<SelectPicker
									data={PROCESS_TYPES?.map((ele) => ({
										label: ele?.title,
										value: ele?.id,
									}))}
									className='w-[325px] select-picker-custom'
									container={() => containerRef.current}
									value={processType?.id}
									onChange={selectProcessType}
									placeholder='Select Process Type'
									disabled={store?.id === EMPTYVALUE}
								/>
							</div>
						</div>
					)}
					{filtersInfo['fromProcess']?.show && (
						<div className='flex flex-col gap-1 items-start mb-3'>
							<span className='text-slate-500 text-[12px]'>
								{filtersInfo['fromProcess']?.text ||
									'From Process'}
							</span>
							<div ref={containerRef} className='relative'>
								{filtersInfo['fromProcess']?.multiSelect ? (
									<CheckPicker
										data={PROCESS_TYPES?.map((ele) => ({
											label: ele?.title,
											value: ele?.id,
										}))}
										className='w-[325px] select-picker-custom'
										container={() => containerRef.current}
										value={fromProcess?.id ?? []}
										onChange={setFromProcess}
										placeholder='Select From Process'
										disabled={store?.id === EMPTYVALUE}
										cleanable={true}
									/>
								) : (
									<SelectPicker
										data={PROCESS_TYPES?.map((ele) => ({
											label: ele?.title,
											value: ele?.id,
										}))}
										className='w-[325px] select-picker-custom'
										container={() => containerRef.current}
										value={fromProcess?.id ?? null}
										onChange={setFromProcessSingle}
										placeholder='Select From Process'
										disabled={store?.id === EMPTYVALUE}
										cleanable={true}
									/>
								)}
							</div>
						</div>
					)}
					{filtersInfo['toProcess']?.show && (
						<div className='flex flex-col gap-1 items-start mb-3'>
							<span className='text-slate-500 text-[12px]'>
								{filtersInfo['toProcess']?.text || 'To Process'}
							</span>
							<div ref={containerRef} className='relative'>
								{filtersInfo['toProcess']?.multiSelect ? (
									<CheckPicker
										data={PROCESS_TYPES?.map((ele) => ({
											label: ele?.title,
											value: ele?.id,
										}))}
										className='w-[325px] select-picker-custom'
										container={() => containerRef.current}
										value={toProcess?.id ?? []}
										onChange={setToProcess}
										placeholder='Select To Process'
										disabled={store?.id === EMPTYVALUE}
										cleanable={true}
									/>
								) : (
									<SelectPicker
										data={PROCESS_TYPES?.map((ele) => ({
											label: ele?.title,
											value: ele?.id,
										}))}
										className='w-[325px] select-picker-custom'
										container={() => containerRef.current}
										value={toProcess?.id ?? null}
										onChange={setToProcessSingle}
										placeholder='Select To Process'
										disabled={store?.id === EMPTYVALUE}
										cleanable={true}
									/>
								)}
							</div>
						</div>
					)}
					{filtersInfo['allProcessType']?.show && (
						<div className='flex flex-col gap-1 items-start mb-3'>
							<span className='text-slate-500 text-[12px]'>
								{filtersInfo['allProcessType']?.text ||
									'All Process Types'}
							</span>
							<div ref={containerRef} className='relative'>
								{filtersInfo['allProcessType']?.multiSelect ? (
									<CheckPicker
										data={ALL_PROCESS_TYPES?.map((ele) => ({
											label: ele?.title,
											value: ele?.id,
										}))}
										onChange={selectAllProcessTypeMulti}
										placeholder='Select Process Type'
										className='w-[325px] select-picker-custom'
										value={allProcessTypeMulti?.id}
										container={() => containerRef.current}
									/>
								) : (
									<SelectPicker
										data={ALL_PROCESS_TYPES?.map((ele) => ({
											label: ele?.title,
											value: ele?.id,
										}))}
										onChange={selectAllProcessType}
										placeholder='Select Process Type'
										className='w-[325px] select-picker-custom'
										value={allProcessType?.id}
										container={() => containerRef.current}
									/>
								)}
							</div>
						</div>
					)}
					{filtersInfo['productionPlan']?.show && (
						<div className='flex flex-col gap-1 items-start mb-3'>
							<span className='text-slate-500 text-[12px]'>
								{filtersInfo['productionPlan']?.text ||
									'Production Plan'}
							</span>
							<div ref={containerRef} className='relative'>
								<CheckPicker
									data={productionPlans?.map((ele) => ({
										label: ele?.description,
										value: ele?.id,
									}))}
									onChange={selectProductionPlan}
									placeholder='Select Production Plan'
									className='w-[325px] select-picker-custom'
									value={productionPlan?.id}
									container={() => containerRef.current}
								/>
							</div>
						</div>
					)}
					{filtersInfo['longTermPlan']?.show && (
						<div className='flex flex-col gap-1 items-start mb-3'>
							<span className='text-slate-500 text-[12px]'>
								{filtersInfo['longTermPlan']?.text ||
									'Long Term Plan'}
							</span>
							<div ref={containerRef} className='relative'>
								{filtersInfo['longTermPlan']?.multiSelect ? (
									<CheckPicker
										data={longTermPlans?.map((ele) => ({
											label: ele?.name,
											value: ele?.id,
										}))}
										onChange={selectLongTermPlanMulti}
										placeholder='Select Long Term Plan'
										className='w-[325px] select-picker-custom'
										value={longtermMultiSelect?.id}
										container={() => containerRef.current}
										disabled={!state?.fromPod?.id}
									/>
								) : (
									<SelectPicker
										data={longTermPlans?.map((ele) => ({
											label: ele?.name,
											value: ele?.id,
										}))}
										onChange={selectLongTermPlan}
										placeholder='Select Long Term Plan'
										className='w-[325px] select-picker-custom'
										value={longtermSingleSelect?.id}
										container={() => containerRef.current}
										disabled={!state?.fromPod?.id}
									/>
								)}
							</div>
						</div>
					)}
				</Accordion.Panel>
			),
		},
		{
			title: 'statusAndTypes',
			isDisabled: filtersInfo['header']?.statusAndTypes !== false,
			panel: (
				<Accordion.Panel
					className='overflow-visible border-b border-[#00000033] border-opacity-20 rounded-none'
					header={
						<Header
							title='Status and Type'
							icon={<LoaderCircle />}
						/>
					}
					defaultExpanded={
						filtersInfo['header']?.statusAndTypes === false
					}
					disabled={filtersInfo['header']?.statusAndTypes !== false}
					caretAs={
						filtersInfo['header']?.statusAndTypes !== false
							? () => {
								return <Ban size={16} />;
							}
							: () => {
								return <ArrowDropDown size={16} />;
							}
					}
				>
					<div className='flex flex-col gap-2 items-start'>
						{filtersInfo['status']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['status']?.text || 'Status'}
								</span>
								<div ref={containerRef} className='relative'>
									<CheckPicker
										data={(
											statusList ?? defaultStatusList
										)?.map((ele) => ({
											label: ele?.title,
											value: ele?.id,
										}))}
										value={status}
										onChange={selectStatus}
										placeholder='Select Status'
										className='w-[325px] text-[12px] select-picker-custom'
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{/* duplicate */}
						{filtersInfo['duplicate']?.show && (
							<div className='flex flex-col gap-1 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['duplicate']?.text ||
										'Duplicate'}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										value={duplicate ?? ''}
										data={filtersInfo['duplicate']?.list}
										className='w-[325px] text-[12px] select-picker-custom'
										onChange={(value) => {
											dispatch({
												type: 'SET_DUPLICATE',
												payload: value,
											});
										}}
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{/* validation */}
						{filtersInfo['validation']?.show && (
							<div className='flex flex-col gap-1 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['validation']?.text ||
										'Validation'}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										value={validation ?? ''}
										data={filtersInfo['validation']?.list}
										className='w-[325px] text-[12px] select-picker-custom'
										onChange={(value) => {
											dispatch({
												type: 'SET_VALIDATION',
												payload: value,
											});
										}}
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{/* identified */}
						{filtersInfo['identified']?.show && (
							<div className='flex flex-col gap-1 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['identified']?.text ||
										'Identified'}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										value={identified ?? ''}
										data={filtersInfo['identified']?.list}
										className='w-[325px] text-[12px] select-picker-custom'
										onChange={(value) => {
											dispatch({
												type: 'SET_IDENTIFIED',
												payload: value,
											});
										}}
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{/* feature */}
						{filtersInfo['feature']?.show && (
							<div className='flex flex-col gap-1 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['feature']?.text || 'Feature'}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										value={feature ?? ''}
										data={filtersInfo['feature']?.list}
										className='w-[325px] text-[12px] select-picker-custom'
										onChange={(value) => {
											dispatch({
												type: 'SET_FEATURE',
												payload: value,
											});
										}}
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{/* type */}
						{filtersInfo['type']?.show && (
							<div className='flex flex-col gap-1 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['type']?.text || 'Type'}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										value={type ?? ''}
										data={filtersInfo['type']?.list.map(
											(item) => {
												return {
													label: item.label,
													value: item.type,
												};
											}
										)}
										className='w-[325px] text-[12px] select-picker-custom'
										onChange={(value) => {
											dispatch({
												type: 'SET_TYPE',
												payload: value,
											});
										}}
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{filtersInfo['featureType']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['featureType']?.text ||
										'Feature Type'}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										value={featureType ?? ''}
										data={typesList?.map((type) => ({
											label: type.name,
											value: type.value,
										}))}
										onChange={selectType}
										placeholder='Select Feature Type'
										className='w-[325px] text-[12px]select-picker-custom'
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{filtersInfo['identificationType']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									Identification Type
								</span>
								<div className='flex w-[325px] h-[35px] justify-center items-center'>
									{identificationTypes?.map((ele, index) => {
										const isSelected =
											ele?.type === identificationType;
										const width = `${100 / identificationTypes.length
											}%`;
										return (
											<div
												key={ele?.id}
												onClick={() =>
													selectIdentificationType(
														ele?.type
													)
												}
												className={`text-[16px] cursor-pointer py-1 text-sm transition-all text-center h-[35px] flex items-center justify-center ${isSelected
													? 'bg-[#e2e8f0] text-black font-medium border-t border-l border-r'
													: 'bg-gray-100 border border-slate-300 hover:bg-gray-200'
													}`}
												style={{
													width,
													borderTopLeftRadius: '4px',
													borderTopRightRadius: '4px',
													borderBottomLeftRadius:
														isSelected
															? '0'
															: '4px',
													borderBottomRightRadius:
														isSelected
															? '0'
															: '4px',
													borderBottom: isSelected
														? '2px solid #0f766e'
														: '',
													marginRight:
														index <
															identificationTypes.length -
															1
															? '-1px'
															: '0',
												}}
											>
												<p className='m-auto'>
													{ele?.type}
												</p>
											</div>
										);
									})}
								</div>
							</div>
						)}
						{filtersInfo['tab']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['tab']?.text || 'Tab'}
								</span>
								<div className='flex w-[325px] h-[35px] justify-center items-center'>
									{filtersInfo['tab']?.list?.map(
										(ele, index) => {
											const isSelected = ele?.id === tab;
											const width = `${100 /
												filtersInfo['tab']?.list?.length
												}%`;
											return (
												<div
													key={ele?.id}
													onClick={() =>
														selectTabType(ele?.id)
													}
													className={`text-[16px] cursor-pointer py-1 text-sm transition-all text-center h-[35px] flex items-center justify-center ${isSelected
														? 'bg-[#e2e8f0] text-black font-medium border-t border-l border-r'
														: 'bg-gray-100 border border-slate-300 hover:bg-gray-200'
														}`}
													style={{
														width,
														borderTopLeftRadius:
															'4px',
														borderTopRightRadius:
															'4px',
														borderBottomLeftRadius:
															isSelected
																? '0'
																: '4px',
														borderBottomRightRadius:
															isSelected
																? '0'
																: '4px',
														borderBottom: isSelected
															? '2px solid #0f766e'
															: '',
														marginRight:
															index <
																filtersInfo['tab']
																	?.list?.length -
																1
																? '-1px'
																: '0',
													}}
												>
													<p className='m-auto'>
														{ele?.type}
													</p>
												</div>
											);
										}
									)}
								</div>
							</div>
						)}
						{filtersInfo['imagesType']?.show && (
							<div className='flex flex-col gap-2 m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['imagesType']?.text ||
										'Image Type'}
								</span>
								<SelectPicker
									value={imagesType ?? ''}
									onChange={selectImagesType}
									data={POSSIBLE_IMAGE_TYPES.map((item) => ({
										label: item.label,
										value: item.id,
									}))}
									placeholder='Select Image Type'
									className='w-[325px] text-[12px] select-picker-custom'
									container={() => containerRef.current}
									cleanable={false}
								/>
							</div>
						)}
						{filtersInfo['customExclusiveFilters']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{
										filtersInfo['customExclusiveFilters']
											?.text
									}
								</span>
								{filtersInfo['customExclusiveFilters']
									?.multiSelect && (
										<div
											ref={containerRef}
											className='relative'
										>
											<CheckPicker
												value={customExclusiveFilters?.id}
												data={
													filtersInfo[
														'customExclusiveFilters'
													]?.filterList
												}
												className='w-[325px] text-[12px] select-picker-custom'
												container={() =>
													containerRef.current
												}
												onChange={
													selectCustomExclusiveFilters
												}
											/>
										</div>
									)}
								{filtersInfo['customExclusiveFilters']
									?.singleSelect && (
										<div
											ref={containerRef}
											className='relative'
										>
											<SelectPicker
												value={customExclusiveFilters?.id}
												data={
													filtersInfo[
														'customExclusiveFilters'
													]?.filterList
												}
												className='w-[325px] text-[12px] select-picker-custom'
												container={() =>
													containerRef.current
												}
												onChange={
													singleSelectCustomExclusiveFilters
												}
											/>
										</div>
									)}
							</div>
						)}
						{filtersInfo['productionPlanStatus']?.show && (
							<div className='flex flex-col gap-1 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['productionPlanStatus']
										?.text || 'Production Plan Status'}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										value={productionPlanStatus ?? 'ALL'}
										data={[
											{ label: 'All', value: 'ALL' },
											{
												label: 'Generated',
												value: 'GENERATED',
											},
											{
												label: 'Not Generated',
												value: 'NOT_GENERATED',
											},
										]}
										className='w-[325px] text-[12px] select-picker-custom'
										onChange={selectproductionPlanStatus}
										container={() => containerRef.current}
										cleanable={false}
									/>
								</div>
							</div>
						)}
						{filtersInfo['paymentType']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['paymentType']?.text}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										value={state?.paymentType}
										data={filtersInfo[
											'paymentType'
										]?.list.map((item) => {
											return {
												label: item.label,
												value: item.type,
											};
										})}
										className='w-[325px] text-[12px] select-picker-custom'
										onChange={(value) =>
											dispatch({
												type: 'SET_PAYMENT_TYPE',
												payload: value,
											})
										}
										cleanable
										placeholder={
											filtersInfo['paymentType']
												?.placeholder ??
											'Select payment type'
										}
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{filtersInfo['paymentStatus']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['paymentStatus']?.text}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										value={state?.paymentStatus}
										data={filtersInfo[
											'paymentStatus'
										]?.list.map((item) => {
											return {
												label: item.label,
												value: item.type,
											};
										})}
										className='w-[325px] text-[12px] select-picker-custom'
										onChange={(value) =>
											dispatch({
												type: 'SET_PAYMENT_STATUS',
												payload: value,
											})
										}
										cleanable
										placeholder='Select payment status'
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
					</div>
				</Accordion.Panel>
			),
		},
		{
			title: 'product',
			isDisabled: filtersInfo['header']?.product !== false,
			panel: (
				<Accordion.Panel
					className='overflow-visible border-b border-[#00000033] rounded-none'
					header={<Header title='Product Based' icon={<Cuboid />} />}
					defaultExpanded={filtersInfo['header']?.product === false}
					disabled={filtersInfo['header']?.product !== false}
					caretAs={
						filtersInfo['header']?.product !== false
							? () => {
								return <Ban size={16} />;
							}
							: () => {
								return <ArrowDropDown size={16} />;
							}
					}
				>
					<div className='flex flex-col gap-2 items-start'>
						{filtersInfo['productCategory']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['productCategory']?.text ||
										'Product Category'}
								</span>
								<div ref={containerRef} className='relative'>
									{filtersInfo['productCategory']
										?.singleSelect ? (
										<SelectPicker
											data={PRODUCT_CATEGORIES?.map(
												(ele) => ({
													label: ele?.title,
													value: ele?.id,
												})
											)}
											value={productCategory?.id}
											onChange={
												selectProductCategorySingle
											}
											placeholder='Select Product Category'
											className='w-[325px] text-[12px] select-picker-custom'
											container={() =>
												containerRef.current
											}
											cleanable
										/>
									) : (
										<CheckPicker
											data={PRODUCT_CATEGORIES?.map(
												(ele) => ({
													label: ele?.title,
													value: ele?.id,
												})
											)}
											value={productCategories?.id}
											onChange={selectProductCategory}
											placeholder='Select Product Categories'
											className='w-[325px] text-[12px] select-picker-custom'
											container={() =>
												containerRef.current
											}
										/>
									)}
								</div>
							</div>
						)}
						{filtersInfo['brand']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['brand']?.text || 'Brand'}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										data={brandsList?.map((item) => ({
											label: item.name,
											value: item.id,
										}))}
										value={brand?.id}
										onChange={selectBrand}
										placeholder='Select Brand'
										cleanable
										searchable
										className='w-[325px] rounded-md bg-[#e2e8f0] select-picker-custom'
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{filtersInfo['skuType']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['skuType']?.text || 'SKU Type'}
								</span>
								<div ref={containerRef} className='relative'>
									{filtersInfo['skuType']?.multiSelect ? (
										<CheckPicker
											data={skuTypesListWithId?.map(
												(skuType) => ({
													label: skuType.displayName,
													value: skuType.title,
												})
											)}
											value={skuTypeMulti}
											onChange={selectSkuTypeMulti}
											placeholder='Select SKU Type'
											cleanable
											searchable
											className='w-[325px] rounded-md bg-[#e2e8f0] select-picker-custom'
											container={() =>
												containerRef.current
											}
										/>
									) : (
										<SelectPicker
											data={skuTypesListWithId?.map(
												(skuType) => ({
													label: skuType.displayName,
													value: skuType.title,
												})
											)}
											value={skuType}
											onChange={selectSkuType}
											placeholder='Select SKU Type'
											cleanable
											searchable
											className='w-[325px] rounded-md bg-[#e2e8f0] select-picker-custom'
											container={() =>
												containerRef.current
											}
										/>
									)}
								</div>
							</div>
						)}
						{filtersInfo['mealType']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['mealType']?.text ||
										'Meal Type'}
								</span>
								<div ref={containerRef} className='relative'>
									{filtersInfo['mealType']?.singleSelect ? (
										<SelectPicker
											data={(mealTypeList ?? [])?.map(
												(mealType) => ({
													label: mealType?.label,
													value: mealType?.mealType,
												})
											)}
											value={mealType}
											onChange={selectMealType}
											placeholder='Select Meal Type'
											className='w-[325px] text-[12px] select-picker-custom'
											container={() =>
												containerRef.current
											}
											cleanable
										/>
									) : (
										<CheckPicker
											data={(mealTypeList ?? [])?.map(
												(mealType) => ({
													label: mealType?.label,
													value: mealType?.mealType,
												})
											)}
											value={mealTypeMulti}
											onChange={selectMealTypeMulti}
											placeholder='Select Meal Types'
											className='w-[325px] text-[12px] select-picker-custom'
											container={() =>
												containerRef.current
											}
											cleanable
										/>
									)}
								</div>
							</div>
						)}
						{filtersInfo['product']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['product']?.text || 'Product'}
								</span>
								<div ref={containerRef} className='relative'>
									{filtersInfo['product']?.singleSelect ? (
										<SelectPicker
											data={(PRODUCTS ?? [])?.map(
												(product) => ({
													label: product?.title,
													value: product?.id,
												})
											)}
											value={product?.id}
											onChange={selectProductSingle}
											placeholder='Select Product'
											className='w-[325px] text-[12px] select-picker-custom'
											container={() =>
												containerRef.current
											}
											cleanable
										/>
									) : (
										<CheckPicker
											data={(PRODUCTS ?? [])?.map(
												(product) => ({
													label: product?.title,
													value: product?.id,
												})
											)}
											value={products?.id}
											onChange={selectProduct}
											placeholder='Select Products'
											className='w-[325px] text-[12px] select-picker-custom'
											container={() =>
												containerRef.current
											}
											cleanable
										/>
									)}
								</div>
							</div>
						)}
						{filtersInfo['productExclusive']?.show
							&& !filtersInfo['conditionalFilters']?.show && (
								<div className='flex flex-col gap-2 items-start m-1'>
									<span className='text-slate-500 text-[12px]'>
										{filtersInfo['productExclusive']?.text || 'Product'}
									</span>

									<div ref={containerRef} className='relative'>
										<SelectPicker
											data={(PRODUCT_EXCLUSIVE_PRODUCTS ?? [])?.map(
												(product) => ({
													label: product?.title,
													value: product?.id,
												})
											)}
											value={productExclusive?.id}
											onChange={selectProductExclusive}
											placeholder={
												filtersInfo['productExclusive']?.placeholder
												|| 'Select Product'
											}
											cleanable
											searchable
											className='w-[325px] text-[12px] select-picker-custom'
											container={() => containerRef.current}
										/>
									</div>
								</div>
							)}
						{filtersInfo['ingredient']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['ingredient']?.text || 'Ingredient'}
								</span>

								<div ref={containerRef} className='relative'>
									<SelectPicker
										data={(INGREDIENT_PRODUCTS ?? [])?.map(
											(product) => ({
												label: product?.title,
												value: product?.id,
											})
										)}
										value={ingredient?.id}
										onChange={selectIngredient}
										placeholder={
											filtersInfo['ingredient']?.placeholder
											|| 'Select Ingredient'
										}
										cleanable
										searchable
										className='w-[325px] text-[12px] select-picker-custom'
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{filtersInfo['productWithVariants']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['productWithVariants']?.text ||
										'Product'}
								</span>
								<div ref={containerRef} className='relative'>
									<CheckTreePicker
										data={filteredProductsForTree}
										value={productWithVariant?.values}
										// onSelect={selectProductWithVariant}
										onChange={handleProductChange}
										onSearch={(keyword) =>
											setProductTreeSearch(keyword)
										}
										placeholder={
											productTreeSearch?.length < 2
												? 'Type 2+ chars to search...'
												: 'Select Products'
										}
										className='w-[325px] text-[12px] select-picker-custom'
										popupStyle={{ width: '325px' }}
										container={() => containerRef.current}
										cleanable
										searchable
										renderTreeNode={(item) => (
											<div className='whitespace-normal break-words text-wrap'>
												{item.label}
											</div>
										)}
										renderMenu={(menu) => (
											<div>
												{productTreeSearch?.length <
													2 && (
														<div className='p-2 text-center text-gray-500 text-xs border-b'>
															Showing first 100
															products. Type to search
															all{' '}
															{productWithVariants?.length ||
																0}{' '}
															products.
														</div>
													)}
												{menu}
											</div>
										)}
									/>
								</div>
							</div>
						)}
						{filtersInfo['conditionalFilters']?.show && (
							<div className='flex flex-col gap-2 items-start'>
								{filtersInfo['group']?.show && (
									<>
										<span className='text-slate-500 text-[12px]'>
											{filtersInfo['group']?.text}
										</span>
										<div
											ref={containerRef}
											className='relative'
										>
											<SelectPicker
												data={GROUPS.map((group) => ({
													label: group.title,
													value: group.id,
												}))}
												value={group?.id}
												onChange={selectGroup}
												placeholder='Select Group'
												cleanable
												searchable
												className='w-[340px] rounded-md bg-[#e2e8f0] select-picker-custom'
												container={() =>
													containerRef.current
												}
											/>
										</div>
									</>
								)}
								<div className='text-slate-800 text-[12px] flex items-center justify-center w-full'>
									{' '}
									OR{' '}
								</div>
								{filtersInfo['productExclusive']?.show && (
									<>
										<span className='text-slate-500 text-[12px]'>
											{
												filtersInfo['productExclusive']
													?.text
											}
										</span>
										<div
											ref={containerRef}
											className='relative'
										>
											<SelectPicker
												data={PRODUCTS.map(
													(product) => ({
														label: product.title,
														value: product.id,
													})
												)}
												value={productExclusive?.id}
												onChange={
													selectProductExclusive
												}
												placeholder='Search Group by Product'
												cleanable
												searchable
												className='w-[340px] rounded-md bg-[#e2e8f0] select-picker-custom'
												container={() =>
													containerRef.current
												}
											/>
										</div>
									</>
								)}
							</div>
						)}
						{filtersInfo['regions']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['regions']?.text || 'Region'}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										data={REGIONS?.map((region) => ({
											label: region.title,
											value: region.id,
										}))}
										value={region?.id}
										onChange={selectRegion}
										placeholder='Select Region'
										cleanable
										searchable
										className='w-[325px] rounded-md bg-[#e2e8f0] select-picker-custom'
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{filtersInfo['raisedBy']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['raisedBy']?.text ||
										'Raised by'}
								</span>
								<div ref={containerRef} className='relative'>
									<SelectPicker
										data={STORES?.map((store) => ({
											label: store.title,
											value: store.id,
										}))}
										value={raisedBy?.id}
										onChange={selectRaisedByStore}
										placeholder='Select Raised by'
										cleanable
										searchable
										className='w-[325px] rounded-md bg-[#e2e8f0] select-picker-custom'
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{filtersInfo['features']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['features']?.text ||
										'Features'}
								</span>
								<div ref={containerRef} className='relative'>
									<CheckPicker
										data={DEFECTS?.map((defect) => ({
											label: defect.title,
											value: defect.id,
										}))}
										value={defects?.id}
										onChange={selectDefects}
										placeholder='Select Features'
										className='w-[325px] text-[12px] select-picker-custom'
										container={() => containerRef.current}
									/>
								</div>
							</div>
						)}
						{filtersInfo['pageLimit']?.show && (
							<div className='flex flex-col gap-2 items-start m-1'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['pageLimit']?.text ||
										'Page Limit'}
								</span>
								<Select
									value={pageLimit ?? ''}
									className='w-[300px]'
									onChange={(e) => {
										setPage(e.target.value);
									}}
									sx={{
										backgroundColor: '#e2e8f0',
										'& .MuiOutlinedInput-notchedOutline': {
											border: 'none',
										},
										'& .MuiSelect-select': {
											color: 'black',
											fontSize: '12px',
											fontWeight: 500,
											padding: '8px 14px',
										},
										'&:hover': {
											backgroundColor: '#e2e8f0',
											'& .MuiOutlinedInput-notchedOutline':
											{
												border: 'none',
											},
										},
									}}
									IconComponent={(props) => (
										<ChevronDown
											{...props}
											className='size-4 text-black'
											style={{
												right: '8px',
												position: 'absolute',
												pointerEvents: 'none',
											}}
										/>
									)}
								>
									{[6, 25, 50, 100].map((page) => {
										return (
											<MenuItem key={page} value={page}>
												{page}
											</MenuItem>
										);
									})}
								</Select>
							</div>
						)}
						{filtersInfo['confidence']?.show && isInternal && (
							<div className='flex flex-col gap-2 items-start m-1 w-full'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['confidence']?.text ||
										'Confidence Range'}
								</span>
								<div className='w-[325px] flex flex-col items-start gap-3'>
									<SelectPicker
										data={CONFIDENCE_LIST}
										value={confidence}
										onChange={selectConfidence}
										placeholder='Select Confidence'
										className='w-[325px] text-[12px] select-picker-custom'
										container={() => containerRef.current}
										searchable={false}
									/>
									<div className='w-[300px] flex flex-row items-center gap-4'>
										{confidence === 'Lessthan' ? (
											<>
												<p className='text-[12px] font-medium min-w-[80px]'>
													{'< ' + sliderValue[1]}
												</p>
												<Slider
													className='w-full [&_.rs-slider-progress-bar]:!bg-black 
												[&_.rs-slider-handle]:!bg-black 
												[&_.rs-slider-handle]:!border-black 
												[&_.rs-slider-handle]:!ring-0 
												[&_.rs-slider-handle]:!shadow-none'
													progress
													value={sliderValue[1]}
													min={minConf}
													max={maxConf}
													step={step}
													onChange={(value) => {
														setSliderValue([
															minConf,
															value,
														]);
													}}
												/>
											</>
										) : confidence === 'Greaterthan' ? (
											<>
												<p className='text-[12px] font-medium min-w-[80px]'>
													{'> ' + sliderValue[0]}
												</p>
												<Slider
													className='w-full [&_.rs-slider-progress-bar]:!bg-black 
												[&_.rs-slider-handle]:!bg-black 
												[&_.rs-slider-handle]:!border-black 
												[&_.rs-slider-handle]:!ring-0 
												[&_.rs-slider-handle]:!shadow-none'
													progress
													value={sliderValue[0]}
													min={minConf}
													max={maxConf}
													step={step}
													onChange={(value) => {
														setSliderValue([
															value,
															maxConf,
														]);
													}}
												/>
											</>
										) : (
											<>
												<p className='text-[12px] font-medium min-w-[80px]'>
													[{' '}
													{Math.min(
														sliderValue[0],
														sliderValue[1]
													)}{' '}
													-{' '}
													{Math.max(
														sliderValue[0],
														sliderValue[1]
													)}{' '}
													]
												</p>
												<RangeSlider
													className='w-full [&_.rs-slider-progress-bar]:!bg-black 
												[&_.rs-slider-handle]:!bg-black 
												[&_.rs-slider-handle]:!border-black 
												[&_.rs-slider-handle]:!ring-0 
												[&_.rs-slider-handle]:!shadow-none'
													progress
													value={sliderValue}
													min={minConf}
													max={maxConf}
													step={step}
													onChange={(value) => {
														const start = Number(
															value?.[0]
														)?.toFixed(2);
														const end = Number(
															value?.[1]
														)?.toFixed(2);
														setSliderValue([
															start,
															end,
														]);
													}}
												/>
											</>
										)}
									</div>
								</div>
							</div>
						)}
						{filtersInfo?.['egaPercentage']?.show && isInternal && (
							<div className='flex flex-col gap-2 items-start m-1 w-full'>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['egaPercentage']?.text ||
										'EGA Percentage'}{' '}
									{'>'}
								</span>
								<div className='w-[300px] flex flex-row items-center gap-4'>
									<p className='text-[12px] font-medium min-w-[50px]'>
										{egaPercentage?.value}%
									</p>
									<Checkbox
										checked={egaPercentage?.checked}
										onChange={handleEgaPercentage}
									/>
									<Slider
										className='w-full [&_.rs-slider-progress-bar]:!bg-black 
										[&_.rs-slider-handle]:!bg-black 
										[&_.rs-slider-handle]:!border-black 
										[&_.rs-slider-handle]:!ring-0 
										[&_.rs-slider-handle]:!shadow-none'
										progress
										value={egaPercentage?.value}
										min={0}
										max={100}
										step={0.1}
										onChange={(value) => {
											setEgaPercentage({
												value: value,
												checked: egaPercentage.checked,
											});
										}}
										disabled={!egaPercentage.checked}
									/>
								</div>
							</div>
						)}
					</div>
				</Accordion.Panel>
			),
		},
		{
			title: 'date',
			isDisabled: filtersInfo['header']?.date !== false,
			panel: (
				<Accordion.Panel
					className='overflow-visible border-b border-[#00000033] rounded-none'
					header={<Header title='Date Range' icon={<Calendar />} />}
					defaultExpanded={filtersInfo['header']?.date === false}
					disabled={filtersInfo['header']?.date !== false}
					caretAs={
						filtersInfo['header']?.date !== false
							? () => {
								return <Ban size={16} />;
							}
							: () => {
								return <ArrowDropDown size={16} />;
							}
					}
				>
					<div className='flex flex-col gap-3 w-full'>
						{orderText && (
							<p className='text-orange-400 text-[12px]'>
								The date filter supports a range of up to 7
								days. For extended data, please export to Excel.
							</p>
						)}
						<div
							className={classes(
								styles['range-container'],
								dateRange?.active ? styles?.applied : ''
							)}
						>
							{filtersInfo['dateRange']?.show && (
								<div className='flex flex-col gap-[12px] items-start m-1 w-full'>
									<span className='text-slate-500 text-[12px]'>
										{filtersInfo['dateRange']?.text ||
											'Date Range'}
									</span>
									{!hideDateRangeTimeType && (
										<div className='flex items-center gap-2 w-[300px]'>
											<Select
												value={timeType?.value ?? ''}
												className={`${styles['time-select']} min-w-[325px]`}
												onChange={selectTimeType}
												sx={{
													backgroundColor: '#e2e8f0',
													'& .MuiOutlinedInput-notchedOutline':
													{
														border: 'none',
													},
													'& .MuiSelect-select': {
														color: 'black',
														fontSize: '12px',
														fontWeight: 500,
														padding: '8px 14px',
													},
													'&:hover': {
														backgroundColor:
															'#e2e8f0',
														'& .MuiOutlinedInput-notchedOutline':
														{
															border: 'none',
														},
													},
												}}
												IconComponent={(props) => (
													<ChevronDown
														{...props}
														className='size-4 text-black'
														style={{
															right: '8px',
															position:
																'absolute',
															pointerEvents:
																'none',
														}}
													/>
												)}
											>
												{(
													timeTypeArray ??
													defaultTimeTypeArr
												).map((type, idx) => {
													return (
														<MenuItem
															// eslint-disable-next-line react/no-array-index-key
															key={idx}
															value={type.value}
														>
															{type.label}
														</MenuItem>
													);
												})}
											</Select>
										</div>
									)}
									<UYDateRange
										placement='auto'
										dateRanges={dateRangeFilterArray}
										onDateRangeChange={setDate}
										enableOnlyBackwardSelection={
											timeType?.disabledFutureDate ??
											false
										}
										width={325}
										customStyle={true}
										cleanable
										onChange={handleDateRangeChange}
									/>
								</div>
							)}
						</div>
						{filtersInfo['dateOnly']?.show && (
							<div className='flex flex-col gap-2 items-start m-1 '>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['dateOnly']?.text ||
										'Date Only'}
								</span>
								<div
									className={classes(
										styles['range-container'],
										dateOnly.active || disableFutureDate
											? styles.applied
											: ''
									)}
									style={{
										display: 'flex',
										alignItems: 'center',
										flexWrap: 'nowrap',
										width: '100%',
									}}
								>
									<DatePickerCustom
										selectedDate={dateOnly?.date}
										selectDate={(rsuiteDate) => {
											setDateOnly({
												active: true,
												date: rsuiteDate,
											});
										}}
										oneTap
										placement='auto'
										defaultValue={dateOnly?.date}
										cleanable={false}
										style={{
											width: '325px',
										}}
										customStyle={true}
										disableFutureDate={disableFutureDate}
									/>
								</div>
							</div>
						)}
						{filtersInfo['dateRangeWithType']?.show && (
							<div className='flex flex-col gap-2 items-start m-1 '>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['dateRangeWithType']?.text ||
										'Date Range with Type'}
								</span>
								<div
									className={classes(
										styles['range-container'],
										styles.applied
									)}
									style={{
										display: 'flex',
										flexDirection: 'column',
										gap: '12px',
										alignItems: 'flex-start',
										justifyContent: 'flex-start',
										width: '100%',
										opacity:
											productionPlan?.id?.length > 0
												? '0.5'
												: '1',
										pointerEvents:
											productionPlan?.id?.length > 0
												? 'none'
												: 'auto',
									}}
								>
									<Select
										value={timeType?.value ?? ''}
										onChange={selectTimeType}
										className='w-[325px]'
										sx={{
											backgroundColor: '#e2e8f0',
											'& .MuiOutlinedInput-notchedOutline':
											{
												border: 'none',
											},
											'& .MuiSelect-select': {
												color: 'black',
												fontSize: '12px',
												fontWeight: 500,
												padding: '8px 14px',
											},
											'&:hover': {
												backgroundColor: '#e2e8f0',
												'& .MuiOutlinedInput-notchedOutline':
												{
													border: 'none',
												},
											},
										}}
										IconComponent={(props) => (
											<ChevronDown
												{...props}
												className='size-4 text-black'
												style={{
													right: '8px',
													position: 'absolute',
													pointerEvents: 'none',
												}}
											/>
										)}
									>
										{(
											timeTypeArray ?? defaultTimeTypeArr
										).map((type, idx) => {
											return (
												<MenuItem
													// eslint-disable-next-line react/no-array-index-key
													key={idx}
													value={type.value}
												>
													{type.label}
												</MenuItem>
											);
										})}
									</Select>
									<UYDateRange
										placement='auto'
										dateRanges={dateRangeFilterArray}
										onDateRangeChange={setDate}
										enableOnlyBackwardSelection={false}
										width={325}
										customStyle={true}
									/>
								</div>
							</div>
						)}
						{filtersInfo['dateRangeOnly']?.show && (
							<div
								className={classes(
									styles['range-container'],
									filtersInfo['dateRangeOnly']?.show
										? styles.applied
										: ''
								)}
								style={{
									display: 'flex',
									flexDirection: 'column',
									gap: '8px',
									alignItems: 'flex-start',
								}}
							>
								<span className='text-slate-500 text-[12px]'>
									{filtersInfo['dateRangeOnly']?.text ||
										'Date Range Only'}
								</span>
								<UYDateRange
									disabled={
										!filtersInfo['dateRangeOnly']?.show
									}
									placement='auto'
									enableOnlyBackwardSelection={
										filtersInfo['dateRangeOnly']
											?.enableOnlyBackwardSelection ??
										false
									}
									dateRanges={dateRangeFilterArray}
									onDateRangeChange={setDate}
									width={325}
									customStyle={true}
								/>
							</div>
						)}
					</div>
				</Accordion.Panel>
			),
		},
	];

	const sortedPanels = filterData.sort(
		(a, b) => Number(a.isDisabled) - Number(b.isDisabled)
	);

	return (
		<BaseDrawer
			className={styles.root}
			header='Filters'
			open={show}
			onClose={() => toggleFiltersDrawer(false)}
			renderBtns={() => { }}
			size='xs'
			color='slate'
			bodyStyle={{
				overflow: 'hidden',
				display: 'flex',
				flexDirection: 'column',
				height: '100%',
			}}
			style={{
				width: '400px',
			}}
		>
			<form onSubmit={handleSubmit} className='flex flex-col h-full'>
				<div className={styles.header}>
					<div className='flex flex-wrap items-center gap-2'>
						{/* {navStoreFilter?.id && (
							<div className={styles['selected-item']}>
								<Tooltip title={navStoreFilter?.title}>
									<p>
										{navStoreFilter?.title?.length > 18 // eslint-disable-next-line prefer-template
											? navStoreFilter?.title?.substring(
												0,
												18
											) + '...'
											: navStoreFilter?.title}
									</p>
								</Tooltip>
							</div>
						)} */}
						{externalFilters?.map((filterEle) => {
							return (
								<div className={styles['selected-item']}>
									<Tooltip title={filterEle?.title}>
										<p>
											{filterEle?.title?.length > 15
												? // eslint-disable-next-line prefer-template
												filterEle?.title?.substring(
													0,
													15
												) + '...'
												: filterEle?.title}
										</p>
									</Tooltip>
									{filterEle?.removable && (
										<IconButton
											className={styles.remove}
											onClick={() => {
												filterEle?.handleRemove(
													filterEle
												);
												removeFilterEle();
											}}
										>
											<Close />
										</IconButton>
									)}
								</div>
							);
						})}
					</div>
				</div>
				{headerComponent()}
				<div
					className='flex-1 overflow-hidden flex flex-col'
					style={{ marginBottom: '120px' }}
				>
					<Accordion className='flex-1 overflow-auto'>
						<div className={`${styles.customScroll} pb-20`}>
							{sortedPanels.map((panel, idx) => {
								return panel?.panel;
							})}
							{!exportInfo?.hideExportAccordian && (
								<Accordion.Panel
									className='overflow-visible border-b border-[#00000033] rounded-none'
									header={
										<Header
											title='Export'
											icon={<Upload size={16} />}
										/>
									}
									defaultExpanded
									caretAs={() => {
										return <ArrowDropDown size={16} />;
									}}
								>
									<div className='w-full flex flex-col gap-3 '>
										{exportInfo?.showDropDown && (
											<div
												ref={containerRef}
												className='relative'
											>
												<SelectPicker
													className='w-full'
													data={
														exportInfo?.exportTypes
													}
													placeholder='Select a Export Type'
													container={() =>
														containerRef.current
													}
													searchable={false}
													value={exportType}
													onChange={selectExportType}
													cleanable={false}
												/>
											</div>
										)}
										{exportInfo?.showExportBtn && (
											<Button
												className='w-full text-black rounded-md bg-yellow-500 hover:bg-yellow-600 flex flex-row justify-center items-center gap-2'
												onClick={
													exportFrontend
														? handleExportFrontend
														: handleExportFilter
												}
											>
												<Upload size={16} />
												<span className='font-bold normal-case'>
													Export (.csv)
												</span>
											</Button>
										)}
									</div>
								</Accordion.Panel>
							)}
						</div>
					</Accordion>
				</div>
				{!hideFinder && (
					<div className='z-[9999] flex gap-2 justify-center items-center fixed bottom-0 left-0 right-0 w-full p-3 bg-white shadow-lg border-t border-gray-200'>
						<Button
							variant='outlined'
							className='border border-black text-black hover:bg-black-500 hover:bg-gray-100 w-[40%] rounded-md uppercase'
							onClick={() => {
								const resetState = alterInitialState(props?.initialState);
								if (timeTypeArray && timeTypeArray.length > 0) {
									resetState.timeType = {
										value: timeTypeArray[0].value,
										label: timeTypeArray[0].label,
									};
								}
								if (exportInfo?.exportTypes?.length > 0) {
									resetState.exportType =
										exportInfo.exportTypes[0].value;
								}
								// Reset means "back to defaults", and on these screens the
								// default kitchen is the first one - clearing it would leave
								// the page with no scope to query.
								if (isKitchenMandatory && FROMPODSTORES?.[0]?.id) {
									resetState.fromPod = {
										id: FROMPODSTORES[0]?.id,
										name: FROMPODSTORES[0]?.title,
									};
								}
								dispatch({
									type: 'SET_STATE',
									payload: resetState,
								});
								toggleFiltersDrawer(false);
								handleSubmitParams(resetState);
							}}
						>
							Reset
						</Button>
						<Button
							type='submit'
							variant='contained'
							className='bg-teal-600 text-white w-[40%] hover:bg-teal-700 rounded-md uppercase'
							onClick={handleSubmit}
						>
							Apply
						</Button>
					</div>
				)}
			</form>
		</BaseDrawer>
	);
};

ImagesFinder.defaultProps = {
	brands: [],
	products: [
		{
			label: 'Product D',
		},
	],
	onSubmit: () => { },
};

const mapStateToProps = (state) => {
	const stores = state?.form?.STORES?.data?.LIST;
	const { brands } = state.brand;
	const { LIST: productsList } = state.form.ALL_PRODUCTS.data;
	const { DATE_RANGE_FILTER: dateRangeFilter } = state.analytics;
	const { LIST: defectsList } = state.form.DEFECTS.data;
	const { LIST: vendorsList } = state.form.ALL_VENDORS.data;
	const { LIST: buyersList } = state.form.ALL_BUYERS.data;
	const { LIST: productCategoriesList } = state.form.PRODUCT_CATEGORY.data;
	const { LIST: processTypes } = state?.form?.PROCESS_TYPES?.data;
	const { permittedStores } = state?.navigation;
	const { show, data } = state?.drawer?.filtersDrawer;
	const { LIST: productionPlans } = state?.analytics.PRODUCTION_PLANS;
	const { navState } = state.navigation;

	return {
		stores,
		brands,
		productsList,
		dateRangeFilter,
		defectsList,
		buyersList,
		vendorsList,
		productCategoriesList,
		processTypes,
		permittedStores,
		show,
		data,
		productionPlans,
		navState,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleListModal,
	fetchStoresList: formActions.gateway,
	fetchBrands: brandActions.fetchBrands,
	fetchProducts: formActions.gateway,
	setDateRangeFilter: analyticsAction.setDateRangeFilter,
	fetchProductCategoriesList: formActions.gateway,
	fetchAllVendors: formActions.gateway,
	fetchDefects: formActions.gateway,
	fetchProcessTypesList: formActions.gateway,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
	fetchProductionPlans: analyticsAction.gateway,
};

export default connect(mapStateToProps, mapDispatchToProps)(ImagesFinder);
